
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $f5ed4ab2a4d1861b$var$extendStatics = function(d, b) {
    $f5ed4ab2a4d1861b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $f5ed4ab2a4d1861b$var$extendStatics(d, b);
};
function $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $f5ed4ab2a4d1861b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f5ed4ab2a4d1861b$export$18ce0697a983be9b = function() {
    $f5ed4ab2a4d1861b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f5ed4ab2a4d1861b$export$18ce0697a983be9b.apply(this, arguments);
};
function $f5ed4ab2a4d1861b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f5ed4ab2a4d1861b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $f5ed4ab2a4d1861b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $f5ed4ab2a4d1861b$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $f5ed4ab2a4d1861b$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $f5ed4ab2a4d1861b$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $f5ed4ab2a4d1861b$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $f5ed4ab2a4d1861b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $f5ed4ab2a4d1861b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f5ed4ab2a4d1861b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $f5ed4ab2a4d1861b$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $f5ed4ab2a4d1861b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $f5ed4ab2a4d1861b$export$45d3717a4c69092e(o, m, p);
}
function $f5ed4ab2a4d1861b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f5ed4ab2a4d1861b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $f5ed4ab2a4d1861b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f5ed4ab2a4d1861b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $f5ed4ab2a4d1861b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $f5ed4ab2a4d1861b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $f5ed4ab2a4d1861b$export$10c90e4f7922046c(v) {
    return this instanceof $f5ed4ab2a4d1861b$export$10c90e4f7922046c ? (this.v = v, this) : new $f5ed4ab2a4d1861b$export$10c90e4f7922046c(v);
}
function $f5ed4ab2a4d1861b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f5ed4ab2a4d1861b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $f5ed4ab2a4d1861b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $f5ed4ab2a4d1861b$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $f5ed4ab2a4d1861b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $f5ed4ab2a4d1861b$export$19a8beecd37a4c45 === "function" ? $f5ed4ab2a4d1861b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $f5ed4ab2a4d1861b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $f5ed4ab2a4d1861b$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $f5ed4ab2a4d1861b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f5ed4ab2a4d1861b$export$45d3717a4c69092e(result, mod, k);
    }
    $f5ed4ab2a4d1861b$var$__setModuleDefault(result, mod);
    return result;
}
function $f5ed4ab2a4d1861b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $f5ed4ab2a4d1861b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $f5ed4ab2a4d1861b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $f5ed4ab2a4d1861b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $f5ed4ab2a4d1861b$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $f5ed4ab2a4d1861b$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $f5ed4ab2a4d1861b$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $f5ed4ab2a4d1861b$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $f5ed4ab2a4d1861b$export$2e2bcd8739ae039 = {
    __extends: $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a,
    __assign: $f5ed4ab2a4d1861b$export$18ce0697a983be9b,
    __rest: $f5ed4ab2a4d1861b$export$3c9a16f847548506,
    __decorate: $f5ed4ab2a4d1861b$export$29e00dfd3077644b,
    __param: $f5ed4ab2a4d1861b$export$d5ad3fd78186038f,
    __metadata: $f5ed4ab2a4d1861b$export$f1db080c865becb9,
    __awaiter: $f5ed4ab2a4d1861b$export$1050f835b63b671e,
    __generator: $f5ed4ab2a4d1861b$export$67ebef60e6f28a6,
    __createBinding: $f5ed4ab2a4d1861b$export$45d3717a4c69092e,
    __exportStar: $f5ed4ab2a4d1861b$export$f33643c0debef087,
    __values: $f5ed4ab2a4d1861b$export$19a8beecd37a4c45,
    __read: $f5ed4ab2a4d1861b$export$8d051b38c9118094,
    __spread: $f5ed4ab2a4d1861b$export$afc72e2116322959,
    __spreadArrays: $f5ed4ab2a4d1861b$export$6388937ca91ccae8,
    __spreadArray: $f5ed4ab2a4d1861b$export$1216008129fb82ed,
    __await: $f5ed4ab2a4d1861b$export$10c90e4f7922046c,
    __asyncGenerator: $f5ed4ab2a4d1861b$export$e427f37a30a4de9b,
    __asyncDelegator: $f5ed4ab2a4d1861b$export$bbd80228419bb833,
    __asyncValues: $f5ed4ab2a4d1861b$export$e3b29a3d6162315f,
    __makeTemplateObject: $f5ed4ab2a4d1861b$export$4fb47efe1390b86f,
    __importStar: $f5ed4ab2a4d1861b$export$c21735bcef00d192,
    __importDefault: $f5ed4ab2a4d1861b$export$da59b14a69baef04,
    __classPrivateFieldGet: $f5ed4ab2a4d1861b$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $f5ed4ab2a4d1861b$export$d40a35129aaff81f,
    __classPrivateFieldIn: $f5ed4ab2a4d1861b$export$81fdc39f203e4e04,
    __addDisposableResource: $f5ed4ab2a4d1861b$export$88ac25d8e944e405,
    __disposeResources: $f5ed4ab2a4d1861b$export$8f076105dc360e92
};





function $390adda5fd19a2d6$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}


function $18bb82b1635a7e79$export$128a15b65d1b6041(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}


var $026eda5c570ccb60$export$c9648b76fd580c34 = (0, $18bb82b1635a7e79$export$128a15b65d1b6041)(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join("\n  ") : "";
        this.name = "UnsubscriptionError";
        this.errors = errors;
    };
});


function $fb0c758b8faa1e2a$export$dae3f38077fc36c0(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}


var $0c79c60f10e25061$export$f55210826850c514 = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = (0, $f5ed4ab2a4d1861b$export$19a8beecd37a4c45)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ((0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof (0, $026eda5c570ccb60$export$c9648b76fd580c34) ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0, $f5ed4ab2a4d1861b$export$19a8beecd37a4c45)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            $0c79c60f10e25061$var$execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof (0, $026eda5c570ccb60$export$c9648b76fd580c34)) errors = (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)((0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([], (0, $f5ed4ab2a4d1861b$export$8d051b38c9118094)(errors)), (0, $f5ed4ab2a4d1861b$export$8d051b38c9118094)(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new (0, $026eda5c570ccb60$export$c9648b76fd580c34)(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) $0c79c60f10e25061$var$execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) (0, $fb0c758b8faa1e2a$export$dae3f38077fc36c0)(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0, $fb0c758b8faa1e2a$export$dae3f38077fc36c0)(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
var $0c79c60f10e25061$export$610f9c3ca1a38dd8 = $0c79c60f10e25061$export$f55210826850c514.EMPTY;
function $0c79c60f10e25061$export$4f9221cbada3c4fc(value) {
    return value instanceof $0c79c60f10e25061$export$f55210826850c514 || value && "closed" in value && (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(value.remove) && (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(value.add) && (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(value.unsubscribe);
}
function $0c79c60f10e25061$var$execFinalizer(finalizer) {
    if ((0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(finalizer)) finalizer();
    else finalizer.unsubscribe();
}


var $6c9b71106df82c02$export$e19cd5f9376f8cee = function(_super) {
    (0, $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a)(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}((0, $0c79c60f10e25061$export$f55210826850c514));



var $a03c46c28b149d0f$export$f0ca5e16f6f68711 = {
    setInterval: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $a03c46c28b149d0f$export$f0ca5e16f6f68711.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setInterval) return delegate.setInterval.apply(delegate, (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $f5ed4ab2a4d1861b$export$8d051b38c9118094)(args)));
        return setInterval.apply(void 0, (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $f5ed4ab2a4d1861b$export$8d051b38c9118094)(args)));
    },
    clearInterval: function(handle) {
        var delegate = $a03c46c28b149d0f$export$f0ca5e16f6f68711.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearInterval) || clearInterval)(handle);
    },
    delegate: undefined
};



var $2552988672225634$export$b5369ffd7cb2211b = function(_super) {
    (0, $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a)(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        var _a;
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.pending = true;
        this.delay = delay;
        this.id = (_a = this.id) !== null && _a !== void 0 ? _a : this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, _id, delay) {
        if (delay === void 0) delay = 0;
        return (0, $a03c46c28b149d0f$export$f0ca5e16f6f68711).setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(_scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay != null && this.delay === delay && this.pending === false) return id;
        if (id != null) (0, $a03c46c28b149d0f$export$f0ca5e16f6f68711).clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error("executing a cancelled action");
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, _delay) {
        var errored = false;
        var errorValue;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = e ? e : new Error("Scheduled action threw falsy error");
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype.unsubscribe = function() {
        if (!this.closed) {
            var _a = this, id = _a.id, scheduler = _a.scheduler;
            var actions = scheduler.actions;
            this.work = this.state = this.scheduler = null;
            this.pending = false;
            (0, $fb0c758b8faa1e2a$export$dae3f38077fc36c0)(actions, this);
            if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
            this.delay = null;
            _super.prototype.unsubscribe.call(this);
        }
    };
    return AsyncAction;
}((0, $6c9b71106df82c02$export$e19cd5f9376f8cee));




var $5bd7469f2b0fbe5b$export$a01aa5c744e19a32 = {
    schedule: function(callback) {
        var request = requestAnimationFrame;
        var cancel = cancelAnimationFrame;
        var delegate = $5bd7469f2b0fbe5b$export$a01aa5c744e19a32.delegate;
        if (delegate) {
            request = delegate.requestAnimationFrame;
            cancel = delegate.cancelAnimationFrame;
        }
        var handle = request(function(timestamp) {
            cancel = undefined;
            callback(timestamp);
        });
        return new (0, $0c79c60f10e25061$export$f55210826850c514)(function() {
            return cancel === null || cancel === void 0 ? void 0 : cancel(handle);
        });
    },
    requestAnimationFrame: function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var delegate = $5bd7469f2b0fbe5b$export$a01aa5c744e19a32.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.requestAnimationFrame) || requestAnimationFrame).apply(void 0, (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([], (0, $f5ed4ab2a4d1861b$export$8d051b38c9118094)(args)));
    },
    cancelAnimationFrame: function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var delegate = $5bd7469f2b0fbe5b$export$a01aa5c744e19a32.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.cancelAnimationFrame) || cancelAnimationFrame).apply(void 0, (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([], (0, $f5ed4ab2a4d1861b$export$8d051b38c9118094)(args)));
    },
    delegate: undefined
};


var $6304afbe8e115d4c$export$20b61f85ef6e6915 = function(_super) {
    (0, $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a)(AnimationFrameAction, _super);
    function AnimationFrameAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AnimationFrameAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        scheduler.actions.push(this);
        return scheduler._scheduled || (scheduler._scheduled = (0, $5bd7469f2b0fbe5b$export$a01aa5c744e19a32).requestAnimationFrame(function() {
            return scheduler.flush(undefined);
        }));
    };
    AnimationFrameAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        var _a;
        if (delay === void 0) delay = 0;
        if (delay != null ? delay > 0 : this.delay > 0) return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        var actions = scheduler.actions;
        if (id != null && ((_a = actions[actions.length - 1]) === null || _a === void 0 ? void 0 : _a.id) !== id) {
            (0, $5bd7469f2b0fbe5b$export$a01aa5c744e19a32).cancelAnimationFrame(id);
            scheduler._scheduled = undefined;
        }
        return undefined;
    };
    return AnimationFrameAction;
}((0, $2552988672225634$export$b5369ffd7cb2211b));




var $61cacee395c43eea$export$c1895ea2d519a677 = {
    now: function() {
        return ($61cacee395c43eea$export$c1895ea2d519a677.delegate || Date).now();
    },
    delegate: undefined
};


var $afeba06f7c4a1139$export$d3e54bb8584cda7c = function() {
    function Scheduler(schedulerActionCtor, now) {
        if (now === void 0) now = Scheduler.now;
        this.schedulerActionCtor = schedulerActionCtor;
        this.now = now;
    }
    Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.schedulerActionCtor(this, work).schedule(state, delay);
    };
    Scheduler.now = (0, $61cacee395c43eea$export$c1895ea2d519a677).now;
    return Scheduler;
}();


var $ef016f6d4d466007$export$4114a3ec92faa3c6 = function(_super) {
    (0, $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a)(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) now = (0, $afeba06f7c4a1139$export$d3e54bb8584cda7c).now;
        var _this = _super.call(this, SchedulerAction, now) || this;
        _this.actions = [];
        _this._active = false;
        return _this;
    }
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this._active) {
            actions.push(action);
            return;
        }
        var error;
        this._active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift());
        this._active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}((0, $afeba06f7c4a1139$export$d3e54bb8584cda7c));


var $a9319362b2c6ac5f$export$5ac76215a6c70aaa = function(_super) {
    (0, $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a)(AnimationFrameScheduler, _super);
    function AnimationFrameScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnimationFrameScheduler.prototype.flush = function(action) {
        this._active = true;
        var flushId = this._scheduled;
        this._scheduled = undefined;
        var actions = this.actions;
        var error;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while ((action = actions[0]) && action.id === flushId && actions.shift());
        this._active = false;
        if (error) {
            while((action = actions[0]) && action.id === flushId && actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AnimationFrameScheduler;
}((0, $ef016f6d4d466007$export$4114a3ec92faa3c6));


var $9864f9013a045943$export$4dc84b80a0d0c8da = new (0, $a9319362b2c6ac5f$export$5ac76215a6c70aaa)((0, $6304afbe8e115d4c$export$20b61f85ef6e6915));
var $9864f9013a045943$export$1402cba6a733f33a = $9864f9013a045943$export$4dc84b80a0d0c8da;



var $ba036f2388dbd8ad$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === "number" && typeof x !== "function";
};



function $eb70e2f33aab6e41$export$4369c812aac99591(value) {
    return (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(value === null || value === void 0 ? void 0 : value.then);
}





var $55472713ab39a4da$export$e506a1d27d1eaa20 = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};




var $747d70177225ac2e$export$365aa6bd3c788e3d = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $747d70177225ac2e$export$365aa6bd3c788e3d.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $f5ed4ab2a4d1861b$export$8d051b38c9118094)(args)));
        return setTimeout.apply(void 0, (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $f5ed4ab2a4d1861b$export$8d051b38c9118094)(args)));
    },
    clearTimeout: function(handle) {
        var delegate = $747d70177225ac2e$export$365aa6bd3c788e3d.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};


function $011e5d1bc8793d8f$export$ebf645db02d3e99f(err) {
    (0, $747d70177225ac2e$export$365aa6bd3c788e3d).setTimeout(function() {
        var onUnhandledError = (0, $55472713ab39a4da$export$e506a1d27d1eaa20).onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}


function $b1207576672ff0a1$export$8793edee2d425525() {}


var $6e71844eb8fb8894$export$b7f97edb34bc1f87 = function() {
    return $6e71844eb8fb8894$export$9c8f6e8d39c60cf3("C", undefined, undefined);
}();
function $6e71844eb8fb8894$export$dd472c3d8fe5a85a(error) {
    return $6e71844eb8fb8894$export$9c8f6e8d39c60cf3("E", undefined, error);
}
function $6e71844eb8fb8894$export$ff9346b0d1d30313(value) {
    return $6e71844eb8fb8894$export$9c8f6e8d39c60cf3("N", value, undefined);
}
function $6e71844eb8fb8894$export$9c8f6e8d39c60cf3(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}




var $dee8986d11ecfbd2$var$context = null;
function $dee8986d11ecfbd2$export$d974811edc77eafa(cb) {
    if ((0, $55472713ab39a4da$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) {
        var isRoot = !$dee8986d11ecfbd2$var$context;
        if (isRoot) $dee8986d11ecfbd2$var$context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = $dee8986d11ecfbd2$var$context, errorThrown = _a.errorThrown, error = _a.error;
            $dee8986d11ecfbd2$var$context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
function $dee8986d11ecfbd2$export$3e205fbb5df021e0(err) {
    if ((0, $55472713ab39a4da$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling && $dee8986d11ecfbd2$var$context) {
        $dee8986d11ecfbd2$var$context.errorThrown = true;
        $dee8986d11ecfbd2$var$context.error = err;
    }
}


var $4bd741c10f565752$export$60959659b2c22881 = function(_super) {
    (0, $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0, $0c79c60f10e25061$export$4f9221cbada3c4fc)(destination)) destination.add(_this);
        } else _this.destination = $4bd741c10f565752$export$88d395d20619a0af;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new $4bd741c10f565752$export$94eeb6a328cab6c7(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) $4bd741c10f565752$var$handleStoppedNotification((0, $6e71844eb8fb8894$export$ff9346b0d1d30313)(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) $4bd741c10f565752$var$handleStoppedNotification((0, $6e71844eb8fb8894$export$dd472c3d8fe5a85a)(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) $4bd741c10f565752$var$handleStoppedNotification((0, $6e71844eb8fb8894$export$b7f97edb34bc1f87), this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}((0, $0c79c60f10e25061$export$f55210826850c514));
var $4bd741c10f565752$var$_bind = Function.prototype.bind;
function $4bd741c10f565752$var$bind(fn, thisArg) {
    return $4bd741c10f565752$var$_bind.call(fn, thisArg);
}
var $4bd741c10f565752$var$ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            $4bd741c10f565752$var$handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            $4bd741c10f565752$var$handleUnhandledError(error);
        }
        else $4bd741c10f565752$var$handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            $4bd741c10f565752$var$handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var $4bd741c10f565752$export$94eeb6a328cab6c7 = function(_super) {
    (0, $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && (0, $55472713ab39a4da$export$e506a1d27d1eaa20).useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && $4bd741c10f565752$var$bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && $4bd741c10f565752$var$bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && $4bd741c10f565752$var$bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new $4bd741c10f565752$var$ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}($4bd741c10f565752$export$60959659b2c22881);
function $4bd741c10f565752$var$handleUnhandledError(error) {
    if ((0, $55472713ab39a4da$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) (0, $dee8986d11ecfbd2$export$3e205fbb5df021e0)(error);
    else (0, $011e5d1bc8793d8f$export$ebf645db02d3e99f)(error);
}
function $4bd741c10f565752$var$defaultErrorHandler(err) {
    throw err;
}
function $4bd741c10f565752$var$handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = (0, $55472713ab39a4da$export$e506a1d27d1eaa20).onStoppedNotification;
    onStoppedNotification && (0, $747d70177225ac2e$export$365aa6bd3c788e3d).setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var $4bd741c10f565752$export$88d395d20619a0af = {
    closed: true,
    next: (0, $b1207576672ff0a1$export$8793edee2d425525),
    error: $4bd741c10f565752$var$defaultErrorHandler,
    complete: (0, $b1207576672ff0a1$export$8793edee2d425525)
};



var $9f1965c8ab242a40$export$5ab46cbf6120b33a = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();


function $df305a39c402bbe4$export$f0954fd7d5368655(x) {
    return x;
}


function $d2736e492570b20c$export$a4627e546088548d() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $d2736e492570b20c$export$71f88a61afaa14d7(fns);
}
function $d2736e492570b20c$export$71f88a61afaa14d7(fns) {
    if (fns.length === 0) return 0, $df305a39c402bbe4$export$f0954fd7d5368655;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}





var $2291f71a0036fa02$export$77cea355fa80b5f4 = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = $2291f71a0036fa02$var$isSubscriber(observerOrNext) ? observerOrNext : new (0, $4bd741c10f565752$export$94eeb6a328cab6c7)(observerOrNext, error, complete);
        (0, $dee8986d11ecfbd2$export$d974811edc77eafa)(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $2291f71a0036fa02$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new (0, $4bd741c10f565752$export$94eeb6a328cab6c7)({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[0, $9f1965c8ab242a40$export$5ab46cbf6120b33a] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return (0, $d2736e492570b20c$export$71f88a61afaa14d7)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $2291f71a0036fa02$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $2291f71a0036fa02$var$getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : (0, $55472713ab39a4da$export$e506a1d27d1eaa20).Promise) !== null && _a !== void 0 ? _a : Promise;
}
function $2291f71a0036fa02$var$isObserver(value) {
    return value && (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(value.next) && (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(value.error) && (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(value.complete);
}
function $2291f71a0036fa02$var$isSubscriber(value) {
    return value && value instanceof (0, $4bd741c10f565752$export$60959659b2c22881) || $2291f71a0036fa02$var$isObserver(value) && (0, $0c79c60f10e25061$export$4f9221cbada3c4fc)(value);
}




function $f1a1ff69d6217eb6$export$48c0cddbc99c45c2(input) {
    return (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(input[0, $9f1965c8ab242a40$export$5ab46cbf6120b33a]);
}



function $da57935939ca9c16$export$edb10ab8dd75a915(obj) {
    return Symbol.asyncIterator && (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}


function $9fbc3ed18d763dea$export$7cbe71b9fa263484(input) {
    return new TypeError("You provided " + (input !== null && typeof input === "object" ? "an invalid object" : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}


function $2fe5679b795ca099$export$aa9956be4ae4fe8() {
    if (typeof Symbol !== "function" || !Symbol.iterator) return "@@iterator";
    return Symbol.iterator;
}
var $2fe5679b795ca099$export$6f58e2338da23f4d = $2fe5679b795ca099$export$aa9956be4ae4fe8();



function $82032c4f549f5cd4$export$9652023d9040757(input) {
    return (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(input === null || input === void 0 ? void 0 : input[0, $2fe5679b795ca099$export$6f58e2338da23f4d]);
}




function $42c86ab8e6ccec32$export$cf4785e597badab3(readableStream) {
    return (0, $f5ed4ab2a4d1861b$export$e427f37a30a4de9b)(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return (0, $f5ed4ab2a4d1861b$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4,
                        (0, $f5ed4ab2a4d1861b$export$10c90e4f7922046c)(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, $f5ed4ab2a4d1861b$export$10c90e4f7922046c)(void 0)
                    ];
                case 4:
                    return [
                        2,
                        _b.sent()
                    ];
                case 5:
                    return [
                        4,
                        (0, $f5ed4ab2a4d1861b$export$10c90e4f7922046c)(value)
                    ];
                case 6:
                    return [
                        4,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3,
                        2
                    ];
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
}
function $42c86ab8e6ccec32$export$c088ffafdba7405f(obj) {
    return (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(obj === null || obj === void 0 ? void 0 : obj.getReader);
}





function $73e1b4b68a4d58ca$export$6a9cfa3ebc765910(input) {
    if (input instanceof (0, $2291f71a0036fa02$export$77cea355fa80b5f4)) return input;
    if (input != null) {
        if ((0, $f1a1ff69d6217eb6$export$48c0cddbc99c45c2)(input)) return $73e1b4b68a4d58ca$export$aa3d41784b3267fa(input);
        if ((0, $ba036f2388dbd8ad$export$1e2f57719e155213)(input)) return $73e1b4b68a4d58ca$export$4cb2acdbcda2c253(input);
        if ((0, $eb70e2f33aab6e41$export$4369c812aac99591)(input)) return $73e1b4b68a4d58ca$export$60f45028237c39d1(input);
        if ((0, $da57935939ca9c16$export$edb10ab8dd75a915)(input)) return $73e1b4b68a4d58ca$export$e073fccf36d78cc1(input);
        if ((0, $82032c4f549f5cd4$export$9652023d9040757)(input)) return $73e1b4b68a4d58ca$export$dcccc29c315dd646(input);
        if ((0, $42c86ab8e6ccec32$export$c088ffafdba7405f)(input)) return $73e1b4b68a4d58ca$export$b2dcb11d46e7a4ad(input);
    }
    throw (0, $9fbc3ed18d763dea$export$7cbe71b9fa263484)(input);
}
function $73e1b4b68a4d58ca$export$aa3d41784b3267fa(obj) {
    return new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)(function(subscriber) {
        var obs = obj[0, $9f1965c8ab242a40$export$5ab46cbf6120b33a]();
        if ((0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(obs.subscribe)) return obs.subscribe(subscriber);
        throw new TypeError("Provided object does not correctly implement Symbol.observable");
    });
}
function $73e1b4b68a4d58ca$export$4cb2acdbcda2c253(array) {
    return new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)(function(subscriber) {
        for(var i = 0; i < array.length && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    });
}
function $73e1b4b68a4d58ca$export$60f45028237c39d1(promise) {
    return new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)(function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, $011e5d1bc8793d8f$export$ebf645db02d3e99f));
    });
}
function $73e1b4b68a4d58ca$export$dcccc29c315dd646(iterable) {
    return new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)(function(subscriber) {
        var e_1, _a;
        try {
            for(var iterable_1 = (0, $f5ed4ab2a4d1861b$export$19a8beecd37a4c45)(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()){
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) return;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        subscriber.complete();
    });
}
function $73e1b4b68a4d58ca$export$e073fccf36d78cc1(asyncIterable) {
    return new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)(function(subscriber) {
        $73e1b4b68a4d58ca$var$process(asyncIterable, subscriber).catch(function(err) {
            return subscriber.error(err);
        });
    });
}
function $73e1b4b68a4d58ca$export$b2dcb11d46e7a4ad(readableStream) {
    return $73e1b4b68a4d58ca$export$e073fccf36d78cc1((0, $42c86ab8e6ccec32$export$cf4785e597badab3)(readableStream));
}
function $73e1b4b68a4d58ca$var$process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return (0, $f5ed4ab2a4d1861b$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var value, e_2_1;
        return (0, $f5ed4ab2a4d1861b$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        5,
                        6,
                        11
                    ]);
                    asyncIterable_1 = (0, $f5ed4ab2a4d1861b$export$e3b29a3d6162315f)(asyncIterable);
                    _b.label = 1;
                case 1:
                    return [
                        4,
                        asyncIterable_1.next()
                    ];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [
                        3,
                        4
                    ];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) return [
                        2
                    ];
                    _b.label = 3;
                case 3:
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        3,
                        11
                    ];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = {
                        error: e_2_1
                    };
                    return [
                        3,
                        11
                    ];
                case 6:
                    _b.trys.push([
                        6,
                        ,
                        9,
                        10
                    ]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        _a.call(asyncIterable_1)
                    ];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    if (e_2) throw e_2.error;
                    return [
                        7
                    ];
                case 10:
                    return [
                        7
                    ];
                case 11:
                    subscriber.complete();
                    return [
                        2
                    ];
            }
        });
    });
}




function $73cdb159b7187545$export$ebec8610810318c5(source) {
    return (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(source === null || source === void 0 ? void 0 : source.lift);
}
function $73cdb159b7187545$export$871731df685d7753(init) {
    return function(source) {
        if ($73cdb159b7187545$export$ebec8610810318c5(source)) return source.lift(function(liftedSource) {
            try {
                return init(liftedSource, this);
            } catch (err) {
                this.error(err);
            }
        });
        throw new TypeError("Unable to lift unknown Observable type");
    };
}




function $94684df14c25c18c$export$b9e075132cc6937f(destination, onNext, onComplete, onError, onFinalize) {
    return new $94684df14c25c18c$export$8fbbf0c4d80268e5(destination, onNext, onComplete, onError, onFinalize);
}
var $94684df14c25c18c$export$8fbbf0c4d80268e5 = function(_super) {
    (0, $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a)(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 || _a.call(this));
        }
    };
    return OperatorSubscriber;
}((0, $4bd741c10f565752$export$60959659b2c22881));


function $a5cbdcd6cbcbc1c4$export$871de8747c9eaa88(project, thisArg) {
    return (0, $73cdb159b7187545$export$871731df685d7753)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $94684df14c25c18c$export$b9e075132cc6937f)(subscriber, function(value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}





function $328d0af0ef3aed41$export$a2b7447487315232(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) delay = 0;
    if (repeat === void 0) repeat = false;
    var scheduleSubscription = scheduler.schedule(function() {
        work();
        if (repeat) parentSubscription.add(this.schedule(null, delay));
        else this.unsubscribe();
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) return scheduleSubscription;
}



function $03097568c8340eb2$export$600918ebaa9e0a1b(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function() {
        if (isComplete && !buffer.length && !active) subscriber.complete();
    };
    var outerNext = function(value) {
        return active < concurrent ? doInnerSub(value) : buffer.push(value);
    };
    var doInnerSub = function(value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        (0, $73e1b4b68a4d58ca$export$6a9cfa3ebc765910)(project(value, index++)).subscribe((0, $94684df14c25c18c$export$b9e075132cc6937f)(subscriber, function(innerValue) {
            onBeforeNext === null || onBeforeNext === void 0 || onBeforeNext(innerValue);
            if (expand) outerNext(innerValue);
            else subscriber.next(innerValue);
        }, function() {
            innerComplete = true;
        }, undefined, function() {
            if (innerComplete) try {
                active--;
                var _loop_1 = function() {
                    var bufferedValue = buffer.shift();
                    if (innerSubScheduler) (0, $328d0af0ef3aed41$export$a2b7447487315232)(subscriber, innerSubScheduler, function() {
                        return doInnerSub(bufferedValue);
                    });
                    else doInnerSub(bufferedValue);
                };
                while(buffer.length && active < concurrent)_loop_1();
                checkComplete();
            } catch (err) {
                subscriber.error(err);
            }
        }));
    };
    source.subscribe((0, $94684df14c25c18c$export$b9e075132cc6937f)(subscriber, outerNext, function() {
        isComplete = true;
        checkComplete();
    }));
    return function() {
        additionalFinalizer === null || additionalFinalizer === void 0 || additionalFinalizer();
    };
}



function $6d95d0a3c23e5dc7$export$6b9f6c0d32c093f9(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    if ((0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(resultSelector)) return $6d95d0a3c23e5dc7$export$6b9f6c0d32c093f9(function(a, i) {
        return (0, $a5cbdcd6cbcbc1c4$export$871de8747c9eaa88)(function(b, ii) {
            return resultSelector(a, b, i, ii);
        })((0, $73e1b4b68a4d58ca$export$6a9cfa3ebc765910)(project(a, i)));
    }, concurrent);
    else if (typeof resultSelector === "number") concurrent = resultSelector;
    return (0, $73cdb159b7187545$export$871731df685d7753)(function(source, subscriber) {
        return (0, $03097568c8340eb2$export$600918ebaa9e0a1b)(source, subscriber, project, concurrent);
    });
}






var $785b56a2951e3f7d$var$isArray = Array.isArray;
function $785b56a2951e3f7d$var$callOrApply(fn, args) {
    return $785b56a2951e3f7d$var$isArray(args) ? fn.apply(void 0, (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([], (0, $f5ed4ab2a4d1861b$export$8d051b38c9118094)(args))) : fn(args);
}
function $785b56a2951e3f7d$export$559affaa48f4288d(fn) {
    return (0, $a5cbdcd6cbcbc1c4$export$871de8747c9eaa88)(function(args) {
        return $785b56a2951e3f7d$var$callOrApply(fn, args);
    });
}


var $0f54b2b6fdc78d47$var$nodeEventEmitterMethods = [
    "addListener",
    "removeListener"
];
var $0f54b2b6fdc78d47$var$eventTargetMethods = [
    "addEventListener",
    "removeEventListener"
];
var $0f54b2b6fdc78d47$var$jqueryMethods = [
    "on",
    "off"
];
function $0f54b2b6fdc78d47$export$a36e16046ae8f1bb(target, eventName, options, resultSelector) {
    if ((0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) return $0f54b2b6fdc78d47$export$a36e16046ae8f1bb(target, eventName, options).pipe((0, $785b56a2951e3f7d$export$559affaa48f4288d)(resultSelector));
    var _a = (0, $f5ed4ab2a4d1861b$export$8d051b38c9118094)($0f54b2b6fdc78d47$var$isEventTarget(target) ? $0f54b2b6fdc78d47$var$eventTargetMethods.map(function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler, options);
        };
    }) : $0f54b2b6fdc78d47$var$isNodeStyleEventEmitter(target) ? $0f54b2b6fdc78d47$var$nodeEventEmitterMethods.map($0f54b2b6fdc78d47$var$toCommonHandlerRegistry(target, eventName)) : $0f54b2b6fdc78d47$var$isJQueryStyleEventEmitter(target) ? $0f54b2b6fdc78d47$var$jqueryMethods.map($0f54b2b6fdc78d47$var$toCommonHandlerRegistry(target, eventName)) : [], 2), add = _a[0], remove = _a[1];
    if (!add) {
        if ((0, $ba036f2388dbd8ad$export$1e2f57719e155213)(target)) return (0, $6d95d0a3c23e5dc7$export$6b9f6c0d32c093f9)(function(subTarget) {
            return $0f54b2b6fdc78d47$export$a36e16046ae8f1bb(subTarget, eventName, options);
        })((0, $73e1b4b68a4d58ca$export$6a9cfa3ebc765910)(target));
    }
    if (!add) throw new TypeError("Invalid event target");
    return new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)(function(subscriber) {
        var handler = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return subscriber.next(1 < args.length ? args : args[0]);
        };
        add(handler);
        return function() {
            return remove(handler);
        };
    });
}
function $0f54b2b6fdc78d47$var$toCommonHandlerRegistry(target, eventName) {
    return function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler);
        };
    };
}
function $0f54b2b6fdc78d47$var$isNodeStyleEventEmitter(target) {
    return (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(target.addListener) && (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(target.removeListener);
}
function $0f54b2b6fdc78d47$var$isJQueryStyleEventEmitter(target) {
    return (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(target.on) && (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(target.off);
}
function $0f54b2b6fdc78d47$var$isEventTarget(target) {
    return (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(target.addEventListener) && (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(target.removeEventListener);
}



var $194b9793c8de3d4c$export$8d6b71a2b178fc32 = new (0, $ef016f6d4d466007$export$4114a3ec92faa3c6)((0, $2552988672225634$export$b5369ffd7cb2211b));
var $194b9793c8de3d4c$export$12af436354f1a4f7 = $194b9793c8de3d4c$export$8d6b71a2b178fc32;





function $e61bfa90c5c93286$export$187e35932e88c15c(value) {
    return value && (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(value.schedule);
}


function $ed32e809f62b1d15$export$c03bb0116ee09d4b(value) {
    return value instanceof Date && !isNaN(value);
}


function $9848eae097ed6239$export$9dc4ecf953986f04(dueTime, intervalOrScheduler, scheduler) {
    if (dueTime === void 0) dueTime = 0;
    if (scheduler === void 0) scheduler = (0, $194b9793c8de3d4c$export$12af436354f1a4f7);
    var intervalDuration = -1;
    if (intervalOrScheduler != null) {
        if ((0, $e61bfa90c5c93286$export$187e35932e88c15c)(intervalOrScheduler)) scheduler = intervalOrScheduler;
        else intervalDuration = intervalOrScheduler;
    }
    return new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)(function(subscriber) {
        var due = (0, $ed32e809f62b1d15$export$c03bb0116ee09d4b)(dueTime) ? +dueTime - scheduler.now() : dueTime;
        if (due < 0) due = 0;
        var n = 0;
        return scheduler.schedule(function() {
            if (!subscriber.closed) {
                subscriber.next(n++);
                if (0 <= intervalDuration) this.schedule(undefined, intervalDuration);
                else subscriber.complete();
            }
        }, due);
    });
}


function $9835779f37f00b7c$export$3174cdbf0a0cbc84(period, scheduler) {
    if (period === void 0) period = 0;
    if (scheduler === void 0) scheduler = (0, $194b9793c8de3d4c$export$8d6b71a2b178fc32);
    if (period < 0) period = 0;
    return (0, $9848eae097ed6239$export$9dc4ecf953986f04)(period, period, scheduler);
}



function $05216b7046af236d$export$18aef43295bbe906(concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    return (0, $6d95d0a3c23e5dc7$export$6b9f6c0d32c093f9)((0, $df305a39c402bbe4$export$f0954fd7d5368655), concurrent);
}




var $ce4337d88b881b98$export$ccb33e29d92c9a58 = new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)(function(subscriber) {
    return subscriber.complete();
});
function $ce4337d88b881b98$export$6e22c362a0406a2c(scheduler) {
    return scheduler ? $ce4337d88b881b98$var$emptyScheduled(scheduler) : $ce4337d88b881b98$export$ccb33e29d92c9a58;
}
function $ce4337d88b881b98$var$emptyScheduled(scheduler) {
    return new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}




function $ba29b8cd54e70848$var$last(arr) {
    return arr[arr.length - 1];
}
function $ba29b8cd54e70848$export$9ae19b645239a61b(args) {
    return (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)($ba29b8cd54e70848$var$last(args)) ? args.pop() : undefined;
}
function $ba29b8cd54e70848$export$29534b2f653ae592(args) {
    return (0, $e61bfa90c5c93286$export$187e35932e88c15c)($ba29b8cd54e70848$var$last(args)) ? args.pop() : undefined;
}
function $ba29b8cd54e70848$export$3de14b735070dcd5(args, defaultValue) {
    return typeof $ba29b8cd54e70848$var$last(args) === "number" ? args.pop() : defaultValue;
}






function $642519524078ad18$export$9007f49c319d1ac7(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $73cdb159b7187545$export$871731df685d7753)(function(source, subscriber) {
        source.subscribe((0, $94684df14c25c18c$export$b9e075132cc6937f)(subscriber, function(value) {
            return (0, $328d0af0ef3aed41$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.next(value);
            }, delay);
        }, function() {
            return (0, $328d0af0ef3aed41$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.complete();
            }, delay);
        }, function(err) {
            return (0, $328d0af0ef3aed41$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.error(err);
            }, delay);
        }));
    });
}



function $8c066c1855781072$export$1eb44d8f5f64733b(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $73cdb159b7187545$export$871731df685d7753)(function(source, subscriber) {
        subscriber.add(scheduler.schedule(function() {
            return source.subscribe(subscriber);
        }, delay));
    });
}


function $d0634c04e9b810ea$export$ed8bd553a12b6a30(input, scheduler) {
    return (0, $73e1b4b68a4d58ca$export$6a9cfa3ebc765910)(input).pipe((0, $8c066c1855781072$export$1eb44d8f5f64733b)(scheduler), (0, $642519524078ad18$export$9007f49c319d1ac7)(scheduler));
}





function $a9da845dce0dee6e$export$fc9afd948577f0a8(input, scheduler) {
    return (0, $73e1b4b68a4d58ca$export$6a9cfa3ebc765910)(input).pipe((0, $8c066c1855781072$export$1eb44d8f5f64733b)(scheduler), (0, $642519524078ad18$export$9007f49c319d1ac7)(scheduler));
}



function $ed6a52c067ec61ae$export$b34673931371729a(input, scheduler) {
    return new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)(function(subscriber) {
        var i = 0;
        return scheduler.schedule(function() {
            if (i === input.length) subscriber.complete();
            else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) this.schedule();
            }
        });
    });
}






function $5eee238d90d10414$export$2b75c58ab9b5b766(input, scheduler) {
    return new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)(function(subscriber) {
        var iterator;
        (0, $328d0af0ef3aed41$export$a2b7447487315232)(subscriber, scheduler, function() {
            iterator = input[0, $2fe5679b795ca099$export$6f58e2338da23f4d]();
            (0, $328d0af0ef3aed41$export$a2b7447487315232)(subscriber, scheduler, function() {
                var _a;
                var value;
                var done;
                try {
                    _a = iterator.next(), value = _a.value, done = _a.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else subscriber.next(value);
            }, 0, true);
        });
        return function() {
            return (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return();
        };
    });
}




function $f3a8e4a5f2c234a6$export$7c7f0979b56a32f3(input, scheduler) {
    if (!input) throw new Error("Iterable cannot be null");
    return new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)(function(subscriber) {
        (0, $328d0af0ef3aed41$export$a2b7447487315232)(subscriber, scheduler, function() {
            var iterator = input[Symbol.asyncIterator]();
            (0, $328d0af0ef3aed41$export$a2b7447487315232)(subscriber, scheduler, function() {
                iterator.next().then(function(result) {
                    if (result.done) subscriber.complete();
                    else subscriber.next(result.value);
                });
            }, 0, true);
        });
    });
}











function $7148993af86cca65$export$3385251aeecad28a(input, scheduler) {
    return (0, $f3a8e4a5f2c234a6$export$7c7f0979b56a32f3)((0, $42c86ab8e6ccec32$export$cf4785e597badab3)(input), scheduler);
}


function $e8c5e3708251b5fa$export$49c44dfc2bb21d70(input, scheduler) {
    if (input != null) {
        if ((0, $f1a1ff69d6217eb6$export$48c0cddbc99c45c2)(input)) return (0, $d0634c04e9b810ea$export$ed8bd553a12b6a30)(input, scheduler);
        if ((0, $ba036f2388dbd8ad$export$1e2f57719e155213)(input)) return (0, $ed6a52c067ec61ae$export$b34673931371729a)(input, scheduler);
        if ((0, $eb70e2f33aab6e41$export$4369c812aac99591)(input)) return (0, $a9da845dce0dee6e$export$fc9afd948577f0a8)(input, scheduler);
        if ((0, $da57935939ca9c16$export$edb10ab8dd75a915)(input)) return (0, $f3a8e4a5f2c234a6$export$7c7f0979b56a32f3)(input, scheduler);
        if ((0, $82032c4f549f5cd4$export$9652023d9040757)(input)) return (0, $5eee238d90d10414$export$2b75c58ab9b5b766)(input, scheduler);
        if ((0, $42c86ab8e6ccec32$export$c088ffafdba7405f)(input)) return (0, $7148993af86cca65$export$3385251aeecad28a)(input, scheduler);
    }
    throw (0, $9fbc3ed18d763dea$export$7cbe71b9fa263484)(input);
}



function $afca3285ff834980$export$6788812c4e6611e6(input, scheduler) {
    return scheduler ? (0, $e8c5e3708251b5fa$export$49c44dfc2bb21d70)(input, scheduler) : (0, $73e1b4b68a4d58ca$export$6a9cfa3ebc765910)(input);
}


function $2e63864986133df2$export$4950aa0f605343fb() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $ba29b8cd54e70848$export$29534b2f653ae592)(args);
    var concurrent = (0, $ba29b8cd54e70848$export$3de14b735070dcd5)(args, Infinity);
    var sources = args;
    return !sources.length ? (0, $ce4337d88b881b98$export$ccb33e29d92c9a58) : sources.length === 1 ? (0, $73e1b4b68a4d58ca$export$6a9cfa3ebc765910)(sources[0]) : (0, $05216b7046af236d$export$18aef43295bbe906)(concurrent)((0, $afca3285ff834980$export$6788812c4e6611e6)(sources, scheduler));
}




function $183291bad0f15980$export$9f6ea8e48bc26eab(project, resultSelector) {
    return (0, $73cdb159b7187545$export$871731df685d7753)(function(source, subscriber) {
        var innerSubscriber = null;
        var index = 0;
        var isComplete = false;
        var checkComplete = function() {
            return isComplete && !innerSubscriber && subscriber.complete();
        };
        source.subscribe((0, $94684df14c25c18c$export$b9e075132cc6937f)(subscriber, function(value) {
            innerSubscriber === null || innerSubscriber === void 0 || innerSubscriber.unsubscribe();
            var innerIndex = 0;
            var outerIndex = index++;
            (0, $73e1b4b68a4d58ca$export$6a9cfa3ebc765910)(project(value, outerIndex)).subscribe(innerSubscriber = (0, $94684df14c25c18c$export$b9e075132cc6937f)(subscriber, function(innerValue) {
                return subscriber.next(resultSelector ? resultSelector(value, innerValue, outerIndex, innerIndex++) : innerValue);
            }, function() {
                innerSubscriber = null;
                checkComplete();
            }));
        }, function() {
            isComplete = true;
            checkComplete();
        }));
    });
}





function $4b874ddcbf4a1d4e$export$ac8dfd3a7ad06e80(notifier) {
    return (0, $73cdb159b7187545$export$871731df685d7753)(function(source, subscriber) {
        (0, $73e1b4b68a4d58ca$export$6a9cfa3ebc765910)(notifier).subscribe((0, $94684df14c25c18c$export$b9e075132cc6937f)(subscriber, function() {
            return subscriber.complete();
        }, (0, $b1207576672ff0a1$export$8793edee2d425525)));
        !subscriber.closed && source.subscribe(subscriber);
    });
}





function $992cdff55f780f5c$export$3f23594af5f37336(observerOrNext, error, complete) {
    var tapObserver = (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(observerOrNext) || error || complete ? {
        next: observerOrNext,
        error: error,
        complete: complete
    } : observerOrNext;
    return tapObserver ? (0, $73cdb159b7187545$export$871731df685d7753)(function(source, subscriber) {
        var _a;
        (_a = tapObserver.subscribe) === null || _a === void 0 || _a.call(tapObserver);
        var isUnsub = true;
        source.subscribe((0, $94684df14c25c18c$export$b9e075132cc6937f)(subscriber, function(value) {
            var _a;
            (_a = tapObserver.next) === null || _a === void 0 || _a.call(tapObserver, value);
            subscriber.next(value);
        }, function() {
            var _a;
            isUnsub = false;
            (_a = tapObserver.complete) === null || _a === void 0 || _a.call(tapObserver);
            subscriber.complete();
        }, function(err) {
            var _a;
            isUnsub = false;
            (_a = tapObserver.error) === null || _a === void 0 || _a.call(tapObserver, err);
            subscriber.error(err);
        }, function() {
            var _a, _b;
            if (isUnsub) (_a = tapObserver.unsubscribe) === null || _a === void 0 || _a.call(tapObserver);
            (_b = tapObserver.finalize) === null || _b === void 0 || _b.call(tapObserver);
        }));
    }) : (0, $df305a39c402bbe4$export$f0954fd7d5368655);
}


function $b84c8059b1c60c68$var$shoogle(element) {
    const mouseEnter$ = (0, $0f54b2b6fdc78d47$export$a36e16046ae8f1bb)(element, "mouseenter");
    const mouseLeave$ = (0, $0f54b2b6fdc78d47$export$a36e16046ae8f1bb)(element, "mouseleave");
    const hover$ = (0, $2e63864986133df2$export$4950aa0f605343fb)(mouseEnter$, mouseLeave$);
    const interval$ = (0, $9835779f37f00b7c$export$3174cdbf0a0cbc84)(50, (0, $9864f9013a045943$export$4dc84b80a0d0c8da));
    hover$.pipe((0, $183291bad0f15980$export$9f6ea8e48bc26eab)((event)=>{
        if (event.type === "mouseenter") return interval$.pipe((0, $4b874ddcbf4a1d4e$export$ac8dfd3a7ad06e80)(mouseLeave$), (0, $992cdff55f780f5c$export$3f23594af5f37336)(()=>{
            element.style.fontStyle = element.style.fontStyle === "normal" ? "italic" : "normal";
        }));
        else return (0, $9835779f37f00b7c$export$3174cdbf0a0cbc84)(0, (0, $9864f9013a045943$export$4dc84b80a0d0c8da)).pipe((0, $992cdff55f780f5c$export$3f23594af5f37336)(()=>{
            element.style.fontStyle = "normal";
        }));
    })).subscribe();
}
var $b84c8059b1c60c68$export$2e2bcd8739ae039 = $b84c8059b1c60c68$var$shoogle;


// |Client| Create dom elements out of an input object
// The input object is in the format:
//    - `[name:string, props:Object, children, options:Object]`, or
//    - `text:string`
// `children` can be another input object
// Options can be:
//    { onRef:function(el:DOMElement) } // Returns a reference to the dom element that is created
function $a2db19d3caa692e7$var$domRender(inputObject, target) {
    function createElement(obj) {
        if (typeof obj === "string") return document.createTextNode(obj);
        const [name, props, children, options] = obj;
        let el;
        const svgTags = [
            "svg",
            "circle",
            "rect",
            "path",
            "line",
            "polyline",
            "polygon",
            "text",
            "marker",
            "defs",
            "linearGradient",
            "stop"
        ];
        if (svgTags.includes(name)) el = document.createElementNS("http://www.w3.org/2000/svg", name);
        else el = document.createElement(name);
        if (props) {
            for(let key in props)if (props.hasOwnProperty(key)) {
                if (typeof props[key] === "object") {
                    if (typeof el[key] !== "object") el[key] = {};
                    Object.assign(el[key], props[key]);
                } else el.setAttribute(key, props[key]);
            }
        }
        if (children) {
            if (Array.isArray(children)) children.forEach((child)=>{
                el.appendChild(createElement(child));
            });
            else el.appendChild(createElement(children));
        }
        if (options && options.onRef) options.onRef(el);
        return el;
    }
    const element = createElement(inputObject);
    target.appendChild(element);
    return element;
}
var $a2db19d3caa692e7$export$2e2bcd8739ae039 = $a2db19d3caa692e7$var$domRender;








var $d007028422acc811$export$f708eee25634bc80 = (0, $18bb82b1635a7e79$export$128a15b65d1b6041)(function(_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = "ObjectUnsubscribedError";
        this.message = "object unsubscribed";
    };
});




var $88dc0495baf4925f$export$b6bbab5a9b109038 = function(_super) {
    (0, $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a)(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function(operator) {
        var subject = new $88dc0495baf4925f$export$155189cde295587d(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function() {
        if (this.closed) throw new (0, $d007028422acc811$export$f708eee25634bc80)();
    };
    Subject.prototype.next = function(value) {
        var _this = this;
        (0, $dee8986d11ecfbd2$export$d974811edc77eafa)(function() {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) _this.currentObservers = Array.from(_this.observers);
                try {
                    for(var _b = (0, $f5ed4ab2a4d1861b$export$19a8beecd37a4c45)(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()){
                        var observer = _c.value;
                        observer.next(value);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
        });
    };
    Subject.prototype.error = function(err) {
        var _this = this;
        (0, $dee8986d11ecfbd2$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while(observers.length)observers.shift().error(err);
            }
        });
    };
    Subject.prototype.complete = function() {
        var _this = this;
        (0, $dee8986d11ecfbd2$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while(observers.length)observers.shift().complete();
            }
        });
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function() {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function(subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function(subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) return 0, $0c79c60f10e25061$export$610f9c3ca1a38dd8;
        this.currentObservers = null;
        observers.push(subscriber);
        return new (0, $0c79c60f10e25061$export$f55210826850c514)(function() {
            _this.currentObservers = null;
            (0, $fb0c758b8faa1e2a$export$dae3f38077fc36c0)(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped) subscriber.complete();
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $88dc0495baf4925f$export$155189cde295587d(destination, source);
    };
    return Subject;
}((0, $2291f71a0036fa02$export$77cea355fa80b5f4));
var $88dc0495baf4925f$export$155189cde295587d = function(_super) {
    (0, $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a)(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 || _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 || _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function() {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 || _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : (0, $0c79c60f10e25061$export$610f9c3ca1a38dd8);
    };
    return AnonymousSubject;
}($88dc0495baf4925f$export$b6bbab5a9b109038);




function $a2772f38b84c6d6a$export$ed80d9de1d9df928(options) {
    if (options === void 0) options = {};
    var _a = options.connector, connector = _a === void 0 ? function() {
        return new (0, $88dc0495baf4925f$export$b6bbab5a9b109038)();
    } : _a, _b = options.resetOnError, resetOnError = _b === void 0 ? true : _b, _c = options.resetOnComplete, resetOnComplete = _c === void 0 ? true : _c, _d = options.resetOnRefCountZero, resetOnRefCountZero = _d === void 0 ? true : _d;
    return function(wrapperSource) {
        var connection;
        var resetConnection;
        var subject;
        var refCount = 0;
        var hasCompleted = false;
        var hasErrored = false;
        var cancelReset = function() {
            resetConnection === null || resetConnection === void 0 || resetConnection.unsubscribe();
            resetConnection = undefined;
        };
        var reset = function() {
            cancelReset();
            connection = subject = undefined;
            hasCompleted = hasErrored = false;
        };
        var resetAndUnsubscribe = function() {
            var conn = connection;
            reset();
            conn === null || conn === void 0 || conn.unsubscribe();
        };
        return (0, $73cdb159b7187545$export$871731df685d7753)(function(source, subscriber) {
            refCount++;
            if (!hasErrored && !hasCompleted) cancelReset();
            var dest = subject = subject !== null && subject !== void 0 ? subject : connector();
            subscriber.add(function() {
                refCount--;
                if (refCount === 0 && !hasErrored && !hasCompleted) resetConnection = $a2772f38b84c6d6a$var$handleReset(resetAndUnsubscribe, resetOnRefCountZero);
            });
            dest.subscribe(subscriber);
            if (!connection && refCount > 0) {
                connection = new (0, $4bd741c10f565752$export$94eeb6a328cab6c7)({
                    next: function(value) {
                        return dest.next(value);
                    },
                    error: function(err) {
                        hasErrored = true;
                        cancelReset();
                        resetConnection = $a2772f38b84c6d6a$var$handleReset(reset, resetOnError, err);
                        dest.error(err);
                    },
                    complete: function() {
                        hasCompleted = true;
                        cancelReset();
                        resetConnection = $a2772f38b84c6d6a$var$handleReset(reset, resetOnComplete);
                        dest.complete();
                    }
                });
                (0, $73e1b4b68a4d58ca$export$6a9cfa3ebc765910)(source).subscribe(connection);
            }
        })(wrapperSource);
    };
}
function $a2772f38b84c6d6a$var$handleReset(reset, on) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (on === true) {
        reset();
        return;
    }
    if (on === false) return;
    var onSubscriber = new (0, $4bd741c10f565752$export$94eeb6a328cab6c7)({
        next: function() {
            onSubscriber.unsubscribe();
            reset();
        }
    });
    return (0, $73e1b4b68a4d58ca$export$6a9cfa3ebc765910)(on.apply(void 0, (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([], (0, $f5ed4ab2a4d1861b$export$8d051b38c9118094)(args)))).subscribe(onSubscriber);
}


function $ced6ca9f5d4a0c9c$var$animationFrameObservable() {
    return new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)((subscriber)=>{
        let startTime = performance.now();
        let lastUpdate = startTime;
        function animate() {
            const currentTime = performance.now();
            const deltaTime = currentTime - lastUpdate;
            const time = currentTime - startTime;
            lastUpdate = currentTime;
            subscriber.next([
                deltaTime,
                time
            ]);
            // Continue the animation loop
            requestAnimationFrame(animate);
        }
        // Start the animation loop
        requestAnimationFrame(animate);
        // Teardown logic when the observable is unsubscribed
        return ()=>{
        // No specific teardown needed for requestAnimationFrame
        };
    }).pipe((0, $a2772f38b84c6d6a$export$ed80d9de1d9df928)());
}
var $ced6ca9f5d4a0c9c$export$2e2bcd8739ae039 = $ced6ca9f5d4a0c9c$var$animationFrameObservable;




function $3cf7bf86af55a3de$export$3dea766d36a8935f(predicate, thisArg) {
    return (0, $73cdb159b7187545$export$871731df685d7753)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $94684df14c25c18c$export$b9e075132cc6937f)(subscriber, function(value) {
            return predicate.call(thisArg, value, index++) && subscriber.next(value);
        }));
    });
}


function $526c83f1c3ed1889$var$connectors(targetEl) {
    var count = 0;
    var defsEl;
    const circleDefinition = [
        "circle",
        {
            cx: 3,
            cy: 3,
            r: 3
        }
    ];
    const defsDefinition = [
        "defs",
        null,
        [],
        {
            onRef: (el)=>defsEl = el
        }
    ];
    const svgDefinition = [
        "svg",
        {
            id: "connectors",
            width: "100%",
            height: "100%",
            style: {
                pointerEvents: "none",
                width: "100%",
                height: "100%",
                position: "absolute",
                top: 0,
                left: 0,
                "z-index": 0
            }
        },
        [
            defsDefinition
        ]
    ];
    const svgEl = (0, $a2db19d3caa692e7$export$2e2bcd8739ae039)(svgDefinition, targetEl);
    const updateObserver$ = (0, $ced6ca9f5d4a0c9c$export$2e2bcd8739ae039)();
    return {
        makeConnector: ()=>{
            var id = ++count;
            var startColor = "red";
            var endColor = "green";
            var markerStartEl;
            var markerEndEl;
            var stopStartEl;
            var stopEndEl;
            var gradientEl;
            const markerStartDefinition = [
                "marker",
                {
                    id: "circleStart" + id,
                    markerWidth: 6,
                    markerHeight: 6,
                    refX: 3,
                    refY: 3,
                    orient: "auto",
                    fill: startColor,
                    "stroke-linejoin": "round"
                },
                [
                    circleDefinition
                ],
                {
                    onRef: (el)=>markerStartEl = el
                }
            ];
            const markerEndDefinition = [
                "marker",
                {
                    id: "circleEnd" + id,
                    markerWidth: 6,
                    markerHeight: 6,
                    refX: 3,
                    refY: 3,
                    orient: "auto",
                    fill: endColor,
                    "stroke-linejoin": "round"
                },
                [
                    circleDefinition
                ],
                {
                    onRef: (el)=>markerEndEl = el
                }
            ];
            const stopStart = [
                "stop",
                {
                    "style": "stop-color: rgb(255, 0, 0)",
                    offset: 0
                },
                [],
                {
                    onRef: (el)=>stopStartEl = el
                }
            ];
            const stopEnd = [
                "stop",
                {
                    "style": "stop-color: rgb(255, 255, 0)",
                    offset: 1
                },
                [],
                {
                    onRef: (el)=>stopEndEl = el
                }
            ];
            const gradientDefinition = [
                "linearGradient",
                {
                    id: "gradient" + id,
                    x1: 0,
                    y1: 0,
                    x2: 0,
                    y2: 0,
                    gradientUnits: "userSpaceOnUse"
                },
                [
                    stopStart,
                    stopEnd
                ],
                {
                    onRef: (el)=>gradientEl = el
                }
            ];
            const pathControls = [
                "M",
                0,
                0,
                "C",
                0,
                0,
                0,
                0,
                0,
                0
            ];
            var props = {
                fill: "none",
                stroke: 'url("#gradient' + id + '")',
                "stroke-width": "1",
                "marker-start": "url(#circleStart" + id + ")",
                "marker-end": "url(#circleEnd" + id + ")"
            };
            var pathEl;
            var needsUpdate = true;
            var updateSubscription = updateObserver$.pipe((0, $3cf7bf86af55a3de$export$3dea766d36a8935f)((_)=>needsUpdate), (0, $992cdff55f780f5c$export$3f23594af5f37336)((_)=>needsUpdate = false)).subscribe((_)=>{
                props.d = pathControls.join(" ");
                if (!pathEl) {
                    // Create the line
                    const pathDefinition = [
                        "path",
                        props
                    ];
                    pathEl = (0, $a2db19d3caa692e7$export$2e2bcd8739ae039)(pathDefinition, svgEl);
                    (0, $a2db19d3caa692e7$export$2e2bcd8739ae039)(markerStartDefinition, defsEl);
                    (0, $a2db19d3caa692e7$export$2e2bcd8739ae039)(markerEndDefinition, defsEl);
                    (0, $a2db19d3caa692e7$export$2e2bcd8739ae039)(gradientDefinition, defsEl);
                } else Object.keys(props).forEach((key)=>{
                    pathEl.setAttribute(key, props[key]);
                });
                stopStartEl.setAttribute("style", "stop-color: " + startColor);
                stopEndEl.setAttribute("style", "stop-color: " + endColor);
                markerStartEl.setAttribute("fill", startColor);
                markerEndEl.setAttribute("fill", endColor);
                gradientEl.setAttribute("x1", pathControls[1]);
                gradientEl.setAttribute("y1", pathControls[2]);
                gradientEl.setAttribute("x2", pathControls[8]);
                gradientEl.setAttribute("y2", pathControls[9]);
            });
            var methods = {
                dispose: ()=>{
                    updateSubscription.unsubscribe();
                    if (pathEl) pathEl.remove();
                },
                from: (x, y, cx, cy, color)=>{
                    pathControls[1] = x;
                    pathControls[2] = y;
                    pathControls[4] = cx;
                    pathControls[5] = cy;
                    startColor = color;
                    needsUpdate = true;
                    return methods;
                },
                to: (x, y, cx, cy, color)=>{
                    pathControls[6] = cx;
                    pathControls[7] = cy;
                    pathControls[8] = x;
                    pathControls[9] = y;
                    endColor = color;
                    needsUpdate = true;
                    return methods;
                }
            };
            return methods;
        }
    };
}
var $526c83f1c3ed1889$export$2e2bcd8739ae039 = $526c83f1c3ed1889$var$connectors;


// |RxJS:Dom| Watch when the content of a webpage changes size. For example, when the window is resized or when the content of a page makes it taller. Useful for calling `render` on any views that are bound to webpage positions.



function $a1d5dd94ab71d79a$export$7843a4469d64c07e(dueTime, scheduler) {
    if (scheduler === void 0) scheduler = (0, $194b9793c8de3d4c$export$8d6b71a2b178fc32);
    return (0, $73cdb159b7187545$export$871731df685d7753)(function(source, subscriber) {
        var activeTask = null;
        var lastValue = null;
        var lastTime = null;
        var emit = function() {
            if (activeTask) {
                activeTask.unsubscribe();
                activeTask = null;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
        };
        function emitWhenIdle() {
            var targetTime = lastTime + dueTime;
            var now = scheduler.now();
            if (now < targetTime) {
                activeTask = this.schedule(undefined, targetTime - now);
                subscriber.add(activeTask);
                return;
            }
            emit();
        }
        source.subscribe((0, $94684df14c25c18c$export$b9e075132cc6937f)(subscriber, function(value) {
            lastValue = value;
            lastTime = scheduler.now();
            if (!activeTask) {
                activeTask = scheduler.schedule(emitWhenIdle, dueTime);
                subscriber.add(activeTask);
            }
        }, function() {
            emit();
            subscriber.complete();
        }, undefined, function() {
            lastValue = activeTask = null;
        }));
    });
}


function $987e5ce25fa759ec$var$pageSizeObservable() {
    // Observable for window resize events
    const resizeObservable = (0, $0f54b2b6fdc78d47$export$a36e16046ae8f1bb)(window, "resize");
    // Observable for content resize using ResizeObserver
    const contentResizeObservable = new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)((subscriber)=>{
        const resizeObserver = new ResizeObserver((entries)=>{
            subscriber.next(entries);
        });
        resizeObserver.observe(document.body);
        // Cleanup function
        return ()=>resizeObserver.disconnect();
    });
    // Merge the two observables and debounce to avoid excessive calls
    const combinedObservable = (0, $2e63864986133df2$export$4950aa0f605343fb)(resizeObservable, contentResizeObservable).pipe((0, $a1d5dd94ab71d79a$export$7843a4469d64c07e)(16, (0, $9864f9013a045943$export$4dc84b80a0d0c8da)), (0, $a2772f38b84c6d6a$export$ed80d9de1d9df928)());
    return combinedObservable;
}
var $987e5ce25fa759ec$export$2e2bcd8739ae039 = $987e5ce25fa759ec$var$pageSizeObservable;


// |DOM| Get a page position for a pixel offset within a DOMElement accounting for 2D css transformations (and 3D transformations with the exception of perspective that needs more work). Origin of `-1,-1` would be left top, `0,0` is the center of the element.
function $bd77175d445eb58c$var$getPointInElementPosition(el, offset = new DOMPoint(0, 0), origin = new DOMPoint(0, 0)) {
    // Get info about element and the window
    const computedStyle = window.getComputedStyle(el);
    const boundingClientRect = el.getBoundingClientRect();
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    offset = DOMPoint.fromPoint(offset);
    // Update the offset to contain also the position on the page
    offset.x += el.offsetWidth / 2 * origin.x;
    offset.y += el.offsetHeight / 2 * origin.y;
    const matrixValues = $bd77175d445eb58c$var$extractMatrixNumbers(computedStyle.transform);
    if (matrixValues) {
        const domMatrix = new DOMMatrix(matrixValues);
        offset = domMatrix.transformPoint(offset);
        offset.x -= matrixValues[4];
        offset.y -= matrixValues[5];
    }
    const centerX = boundingClientRect.left + boundingClientRect.width / 2;
    const centerY = boundingClientRect.top + boundingClientRect.height / 2;
    const centerPoint = new DOMPoint(centerX + scrollLeft, centerY + scrollTop);
    matrixValues;
    offset.x += centerPoint.x;
    offset.y += centerPoint.y;
    return offset;
}
function $bd77175d445eb58c$var$extractMatrixNumbers(transform) {
    const regex = /matrix(?:3d)?\(([^)]+)\)/;
    const matches = transform.match(regex);
    if (matches) return matches[1].split(",").map(parseFloat);
    else // No transformation matrix found
    return null;
}
var $bd77175d445eb58c$export$2e2bcd8739ae039 = $bd77175d445eb58c$var$getPointInElementPosition;





function $307eea2e4a0bb811$export$779c5fb865a0172e(comparator, keySelector) {
    if (keySelector === void 0) keySelector = (0, $df305a39c402bbe4$export$f0954fd7d5368655);
    comparator = comparator !== null && comparator !== void 0 ? comparator : $307eea2e4a0bb811$var$defaultCompare;
    return (0, $73cdb159b7187545$export$871731df685d7753)(function(source, subscriber) {
        var previousKey;
        var first = true;
        source.subscribe((0, $94684df14c25c18c$export$b9e075132cc6937f)(subscriber, function(value) {
            var currentKey = keySelector(value);
            if (first || !comparator(previousKey, currentKey)) {
                first = false;
                previousKey = currentKey;
                subscriber.next(value);
            }
        }));
    });
}
function $307eea2e4a0bb811$var$defaultCompare(a, b) {
    return a === b;
}



function $37811ad0a653ebd7$export$8f9d79d42bff1aac() {
    return (0, $73cdb159b7187545$export$871731df685d7753)(function(source, subscriber) {
        var prev;
        var hasPrev = false;
        source.subscribe((0, $94684df14c25c18c$export$b9e075132cc6937f)(subscriber, function(value) {
            var p = prev;
            prev = value;
            hasPrev && subscriber.next([
                p,
                value
            ]);
            hasPrev = true;
        }));
    });
}





function $502f0b67b57a2b5b$export$de363e709c412c8a(durationSelector, config) {
    return (0, $73cdb159b7187545$export$871731df685d7753)(function(source, subscriber) {
        var _a = config !== null && config !== void 0 ? config : {}, _b = _a.leading, leading = _b === void 0 ? true : _b, _c = _a.trailing, trailing = _c === void 0 ? false : _c;
        var hasValue = false;
        var sendValue = null;
        var throttled = null;
        var isComplete = false;
        var endThrottling = function() {
            throttled === null || throttled === void 0 || throttled.unsubscribe();
            throttled = null;
            if (trailing) {
                send();
                isComplete && subscriber.complete();
            }
        };
        var cleanupThrottling = function() {
            throttled = null;
            isComplete && subscriber.complete();
        };
        var startThrottle = function(value) {
            return throttled = (0, $73e1b4b68a4d58ca$export$6a9cfa3ebc765910)(durationSelector(value)).subscribe((0, $94684df14c25c18c$export$b9e075132cc6937f)(subscriber, endThrottling, cleanupThrottling));
        };
        var send = function() {
            if (hasValue) {
                hasValue = false;
                var value = sendValue;
                sendValue = null;
                subscriber.next(value);
                !isComplete && startThrottle(value);
            }
        };
        source.subscribe((0, $94684df14c25c18c$export$b9e075132cc6937f)(subscriber, function(value) {
            hasValue = true;
            sendValue = value;
            !(throttled && !throttled.closed) && (leading ? send() : startThrottle(value));
        }, function() {
            isComplete = true;
            !(trailing && hasValue && throttled && !throttled.closed) && subscriber.complete();
        }));
    });
}



function $95bbfad9a3a80b79$export$4efe28f192921dd4(duration, scheduler, config) {
    if (scheduler === void 0) scheduler = (0, $194b9793c8de3d4c$export$8d6b71a2b178fc32);
    var duration$ = (0, $9848eae097ed6239$export$9dc4ecf953986f04)(duration, scheduler);
    return (0, $502f0b67b57a2b5b$export$de363e709c412c8a)(function() {
        return duration$;
    }, config);
}


function $e2c8b4876f0a3aef$var$scrollVelocity() {
    // Function to get the current scroll position
    const getScrollPosition = ()=>window.scrollY || document.documentElement.scrollTop;
    // Observable that emits scroll positions at a fixed frame rate
    const scrollPosition$ = (0, $0f54b2b6fdc78d47$export$a36e16046ae8f1bb)(window, "scroll").pipe((0, $95bbfad9a3a80b79$export$4efe28f192921dd4)(0, (0, $9864f9013a045943$export$4dc84b80a0d0c8da)), (0, $a5cbdcd6cbcbc1c4$export$871de8747c9eaa88)(getScrollPosition), (0, $307eea2e4a0bb811$export$779c5fb865a0172e)() // Only emit when scroll position changes
    );
    // Observable that calculates the scroll velocity
    const scrollVelocity$ = scrollPosition$.pipe((0, $37811ad0a653ebd7$export$8f9d79d42bff1aac)(), (0, $a5cbdcd6cbcbc1c4$export$871de8747c9eaa88)(([prev, curr])=>curr - prev), (0, $183291bad0f15980$export$9f6ea8e48bc26eab)((velocity)=>(0, $9835779f37f00b7c$export$3174cdbf0a0cbc84)(1000 / 60).pipe((0, $a5cbdcd6cbcbc1c4$export$871de8747c9eaa88)(()=>velocity))));
    return scrollVelocity$;
}
var $e2c8b4876f0a3aef$export$2e2bcd8739ae039 = $e2c8b4876f0a3aef$var$scrollVelocity;


// |UI| Makes an element drag when subscribed to.

function $7e1a5774bc26420f$var$draggable(el, optionalDownTargetEl) {
    const downTarget = optionalDownTargetEl || el;
    downTarget.ondragstart = function(e) {
        e.preventDefault();
        return false;
    };
    const mouseMove$ = (0, $0f54b2b6fdc78d47$export$a36e16046ae8f1bb)(window, "mousemove");
    const mouseUp$ = (0, $0f54b2b6fdc78d47$export$a36e16046ae8f1bb)(window, "mouseup");
    const mouseOut$ = (0, $0f54b2b6fdc78d47$export$a36e16046ae8f1bb)(window, "mouseleave");
    const mouseDown$ = (0, $0f54b2b6fdc78d47$export$a36e16046ae8f1bb)(downTarget, "mousedown").pipe((0, $3cf7bf86af55a3de$export$3dea766d36a8935f)((event)=>{
        const rect = downTarget.getBoundingClientRect();
        const threshold = 20; // Define the size of the bottom right corner area
        const inBottomRightCorner = event.clientX >= rect.right - threshold && event.clientY >= rect.bottom - threshold;
        return !inBottomRightCorner;
    }));
    const drag$ = mouseDown$.pipe((0, $3cf7bf86af55a3de$export$3dea766d36a8935f)(({ button: button })=>button === 0), (0, $183291bad0f15980$export$9f6ea8e48bc26eab)((startEvent)=>{
        const startX = startEvent.clientX;
        const startY = startEvent.clientY;
        const initialTranslate = el.style.transform.match(/translate\((.+)px, (.+)px\)/);
        const initialX = initialTranslate ? parseFloat(initialTranslate[1]) : 0;
        const initialY = initialTranslate ? parseFloat(initialTranslate[2]) : 0;
        return mouseMove$.pipe((0, $a5cbdcd6cbcbc1c4$export$871de8747c9eaa88)((moveEvent)=>{
            moveEvent.preventDefault();
            const deltaX = moveEvent.clientX - startX;
            const deltaY = moveEvent.clientY - startY;
            return {
                x: initialX + deltaX,
                y: initialY + deltaY
            };
        }), (0, $4b874ddcbf4a1d4e$export$ac8dfd3a7ad06e80)((0, $2e63864986133df2$export$4950aa0f605343fb)(mouseUp$, mouseOut$)));
    }));
    return drag$.pipe((0, $992cdff55f780f5c$export$3f23594af5f37336)((position)=>{
        el.style.transform = `translate(${position.x}px, ${position.y}px)`;
    }));
}
var $7e1a5774bc26420f$export$2e2bcd8739ae039 = $7e1a5774bc26420f$var$draggable;


// |Array| Converts an array like object to an array. Handy for `arguments` or dom selectors
function $7551c051cf6c1741$var$toArray(obj) {
    return Array.prototype.slice.call(obj);
}
var $7551c051cf6c1741$export$2e2bcd8739ae039 = $7551c051cf6c1741$var$toArray;





function $7d538d433736789b$export$b7df5d561049483a(count) {
    return count <= 0 ? function() {
        return 0, $ce4337d88b881b98$export$ccb33e29d92c9a58;
    } : (0, $73cdb159b7187545$export$871731df685d7753)(function(source, subscriber) {
        var seen = 0;
        source.subscribe((0, $94684df14c25c18c$export$b9e075132cc6937f)(subscriber, function(value) {
            if (++seen <= count) {
                subscriber.next(value);
                if (count <= seen) subscriber.complete();
            }
        }));
    });
}



function $a6dda5b21e9827a9$var$intersectionObservable(el, options = {}) {
    return new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)((subscriber)=>{
        // Create the intersection observer
        const observer = new IntersectionObserver((entries, observer)=>{
            entries.forEach((entry)=>{
                subscriber.next(entry);
            });
        }, options);
        // Start observing the provided element
        observer.observe(el);
        // Cleanup function when the observable is unsubscribed
        return ()=>observer.disconnect();
    }).pipe((0, $a2772f38b84c6d6a$export$ed80d9de1d9df928)());
}
var $a6dda5b21e9827a9$export$2e2bcd8739ae039 = $a6dda5b21e9827a9$var$intersectionObservable;



var $567bcbf2c48d6a1e$var$edits$ = new (0, $88dc0495baf4925f$export$b6bbab5a9b109038)(null);
function $567bcbf2c48d6a1e$var$getEdits() {
    return $567bcbf2c48d6a1e$var$edits$;
}
var $567bcbf2c48d6a1e$export$2e2bcd8739ae039 = $567bcbf2c48d6a1e$var$getEdits;




var $c50b073a7df50bca$var$pageSizeObservable$ = (0, $987e5ce25fa759ec$export$2e2bcd8739ae039)();
var $7163176da8105974$exports = {};
const $7163176da8105974$var$breakpoints = new Map();
// Tailwind breakpoints
$7163176da8105974$var$breakpoints.set("default", 0);
$7163176da8105974$var$breakpoints.set("small", 500);
$7163176da8105974$var$breakpoints.set("medium", 768);
$7163176da8105974$var$breakpoints.set("large", 1024);
$7163176da8105974$var$breakpoints.set("xlarge", 1280);
$7163176da8105974$exports = $7163176da8105974$var$breakpoints;


function $c50b073a7df50bca$export$37d76b99a571409a(width) {
    let currentBreakpoint = "default";
    for (let [breakpoint, minWidth] of $7163176da8105974$exports){
        if (innerWidth >= minWidth) currentBreakpoint = breakpoint;
        else break;
    }
    return currentBreakpoint;
}
function $c50b073a7df50bca$export$b74b67df3223ddfa() {
    return $7163176da8105974$exports;
}
var $c50b073a7df50bca$var$latest = "default";
var $c50b073a7df50bca$var$widthBreakpointObservable$ = $c50b073a7df50bca$var$pageSizeObservable$.pipe((0, $a5cbdcd6cbcbc1c4$export$871de8747c9eaa88)((_)=>window.innerWidth), (0, $307eea2e4a0bb811$export$779c5fb865a0172e)(), (0, $a5cbdcd6cbcbc1c4$export$871de8747c9eaa88)($c50b073a7df50bca$export$37d76b99a571409a), (0, $992cdff55f780f5c$export$3f23594af5f37336)((v)=>$c50b073a7df50bca$var$latest = v), (0, $a2772f38b84c6d6a$export$ed80d9de1d9df928)());
function $c50b073a7df50bca$export$a8d898299aedf3c4() {
    return $c50b073a7df50bca$var$widthBreakpointObservable$;
}
function $c50b073a7df50bca$export$82919ec0c053a4c9() {
    return $c50b073a7df50bca$var$latest;
}
var $c50b073a7df50bca$export$2e2bcd8739ae039 = $c50b073a7df50bca$export$a8d898299aedf3c4;


// |UI| Makes an element resizable when subscribed to

function $524b36d8da542765$var$resizable(el, options = {}) {
    const { optionalDownTargetEl: optionalDownTargetEl = el, preserveAspect: preserveAspect = true, widthOnly: widthOnly = false } = options;
    const downTarget = optionalDownTargetEl;
    downTarget.ondragstart = function(e) {
        e.preventDefault();
        return false;
    };
    const mouseMove$ = (0, $0f54b2b6fdc78d47$export$a36e16046ae8f1bb)(window, "mousemove");
    const mouseUp$ = (0, $0f54b2b6fdc78d47$export$a36e16046ae8f1bb)(window, "mouseup");
    const mouseOut$ = (0, $0f54b2b6fdc78d47$export$a36e16046ae8f1bb)(window, "mouseleave");
    const mouseDown$ = (0, $0f54b2b6fdc78d47$export$a36e16046ae8f1bb)(downTarget, "mousedown").pipe((0, $3cf7bf86af55a3de$export$3dea766d36a8935f)((event)=>{
        const rect = downTarget.getBoundingClientRect();
        const threshold = 20; // Define the size of the bottom right corner area
        const inBottomRightCorner = event.clientX >= rect.right - threshold && event.clientY >= rect.bottom - threshold;
        return inBottomRightCorner;
    }));
    const resize$ = mouseDown$.pipe((0, $183291bad0f15980$export$9f6ea8e48bc26eab)((startEvent)=>{
        const startX = startEvent.clientX;
        const startY = startEvent.clientY;
        const startWidth = el.offsetWidth;
        const startHeight = el.offsetHeight;
        const aspectRatio = startWidth / startHeight;
        return mouseMove$.pipe((0, $a5cbdcd6cbcbc1c4$export$871de8747c9eaa88)((moveEvent)=>{
            moveEvent.preventDefault();
            const deltaX = moveEvent.clientX - startX;
            const deltaY = moveEvent.clientY - startY;
            let newWidth = startWidth + deltaX;
            let newHeight = startHeight + deltaY;
            if (widthOnly) newHeight = 0;
            else if (preserveAspect) {
                if (newWidth / newHeight > aspectRatio) newHeight = newWidth / aspectRatio;
                else newWidth = newHeight * aspectRatio;
            }
            return {
                width: Math.floor(newWidth),
                height: Math.floor(newHeight)
            };
        }), (0, $4b874ddcbf4a1d4e$export$ac8dfd3a7ad06e80)((0, $2e63864986133df2$export$4950aa0f605343fb)(mouseUp$, mouseOut$)));
    }));
    return resize$.pipe((0, $992cdff55f780f5c$export$3f23594af5f37336)((size)=>{
        el.style["max-width"] = `${size.width}px`;
        if (size.height) el.style.height = `${size.height}px`;
        el.style.width = `${size.width}px`;
    //el.style.transform = `translate(${size.translateX}px, ${size.translateY}px)`;
    }));
}
var $524b36d8da542765$export$2e2bcd8739ae039 = $524b36d8da542765$var$resizable;


// |RxJS:String| A typewriter effect that emits characters to add and remove. 

function $e8f8d6a497df44f8$export$b314777ae20abca9() {
    return (0, $05216b7046af236d$export$18aef43295bbe906)(1);
}




function $4195388abc69bf39$export$ee1b3e54f0441b22() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return (0, $e8f8d6a497df44f8$export$b314777ae20abca9)()((0, $afca3285ff834980$export$6788812c4e6611e6)(args, (0, $ba29b8cd54e70848$export$29534b2f653ae592)(args)));
}



function $cea8e04dbe575457$export$c28c8388be0ab31a(project, resultSelector) {
    return (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(resultSelector) ? (0, $6d95d0a3c23e5dc7$export$6b9f6c0d32c093f9)(project, resultSelector, 1) : (0, $6d95d0a3c23e5dc7$export$6b9f6c0d32c093f9)(project, 1);
}







function $d2f8eca01cb6c1a6$export$6953b97c7d866605() {
    return (0, $73cdb159b7187545$export$871731df685d7753)(function(source, subscriber) {
        source.subscribe((0, $94684df14c25c18c$export$b9e075132cc6937f)(subscriber, (0, $b1207576672ff0a1$export$8793edee2d425525)));
    });
}



function $a78699d26319dd58$export$e0eaf3a86c03b2ad(value) {
    return (0, $a5cbdcd6cbcbc1c4$export$871de8747c9eaa88)(function() {
        return value;
    });
}




function $a58b19dc01ce0b85$export$286ca829307725c9(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) return function(source) {
        return (0, $4195388abc69bf39$export$ee1b3e54f0441b22)(subscriptionDelay.pipe((0, $7d538d433736789b$export$b7df5d561049483a)(1), (0, $d2f8eca01cb6c1a6$export$6953b97c7d866605)()), source.pipe($a58b19dc01ce0b85$export$286ca829307725c9(delayDurationSelector)));
    };
    return (0, $6d95d0a3c23e5dc7$export$6b9f6c0d32c093f9)(function(value, index) {
        return (0, $73e1b4b68a4d58ca$export$6a9cfa3ebc765910)(delayDurationSelector(value, index)).pipe((0, $7d538d433736789b$export$b7df5d561049483a)(1), (0, $a78699d26319dd58$export$e0eaf3a86c03b2ad)(value));
    });
}



function $4477933faa875af1$export$1391212d75b2ee65(due, scheduler) {
    if (scheduler === void 0) scheduler = (0, $194b9793c8de3d4c$export$8d6b71a2b178fc32);
    var duration = (0, $9848eae097ed6239$export$9dc4ecf953986f04)(due, scheduler);
    return (0, $a58b19dc01ce0b85$export$286ca829307725c9)(function() {
        return duration;
    });
}



function $18efc9ac364e445d$export$9f77e0932fb78f72(project, concurrent, scheduler) {
    if (concurrent === void 0) concurrent = Infinity;
    concurrent = (concurrent || 0) < 1 ? Infinity : concurrent;
    return (0, $73cdb159b7187545$export$871731df685d7753)(function(source, subscriber) {
        return (0, $03097568c8340eb2$export$600918ebaa9e0a1b)(source, subscriber, project, concurrent, undefined, true, scheduler);
    });
}



function $3f0659d06615d3d8$export$ba255e9e49e00608() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $ba29b8cd54e70848$export$29534b2f653ae592)(args);
    return (0, $afca3285ff834980$export$6788812c4e6611e6)(args, scheduler);
}


// |Array| Returns a iterator to keep cycling through all the elements of an array.
function $db6b1f59f31bed6d$var$cycle(arr) {
    var idx = -1;
    return function() {
        if (++idx >= arr.length) idx = 0;
        return arr[idx];
    };
}
var $db6b1f59f31bed6d$export$2e2bcd8739ae039 = $db6b1f59f31bed6d$var$cycle;


// |Math| Return a random number between two values.
function $fdc83e8c8ea069df$var$randomBetween(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
var $fdc83e8c8ea069df$export$2e2bcd8739ae039 = $fdc83e8c8ea069df$var$randomBetween;


function $a80cf5dc979e0ed3$var$makeTypewriter({ el: el, addCharacter: addCharacter, removeCharacter: removeCharacter, strings: strings, startWith: startWith = "", loop: loop = true, delayStart: delayStart = 0, onFinishString: onFinishString = ()=>{} }) {
    var stringCount = 0;
    var addCharacter = addCharacter || function(character) {
        // Add character to input placeholder
        if (el.innerText.endsWith("|")) el.innerText = el.innerText.slice(0, -1) + character + "|";
        else el.innerText = el.innerText + character + "|";
        // Return null to skip internal adding of dom node
        return null;
    };
    var removeCharacter = removeCharacter || function({ character: character }) {
        if (el.innerText) {
            if (el.innerText.endsWith("|")) el.innerText = el.innerText.slice(0, -2) + "|";
            else el.innerText = el.innerText.slice(0, -1) + "|";
        }
    };
    // Helper function to cycle through the provided strings
    const stringCycler = (0, $db6b1f59f31bed6d$export$2e2bcd8739ae039)(strings);
    // Function to create the typewriter effect for a given string
    const createTypewriterEffect$ = (currentString, deleteOnly = false)=>{
        // Observable to handle adding characters one by one
        const countUp$ = (0, $afca3285ff834980$export$6788812c4e6611e6)(currentString).pipe((0, $cea8e04dbe575457$export$c28c8388be0ab31a)((char, idx)=>{
            var delayInterval;
            switch(char){
                case " ":
                    delayInterval = (0, $fdc83e8c8ea069df$export$2e2bcd8739ae039)(100, 200);
                    break;
                case "\u2026":
                    delayInterval = (0, $fdc83e8c8ea069df$export$2e2bcd8739ae039)(300, 400);
                    break;
                default:
                    delayInterval = (0, $fdc83e8c8ea069df$export$2e2bcd8739ae039)(40, 70);
            }
            if (idx === 0) delayInterval = 0;
            return (0, $3f0659d06615d3d8$export$ba255e9e49e00608)(char).pipe((0, $4477933faa875af1$export$1391212d75b2ee65)(delayInterval, (0, $9864f9013a045943$export$4dc84b80a0d0c8da)), (0, $992cdff55f780f5c$export$3f23594af5f37336)(()=>addCharacter(char)) // Add character
            );
        }), (0, $992cdff55f780f5c$export$3f23594af5f37336)({
            complete: ()=>{
                onFinishString(++stringCount);
            }
        }));
        // Observable to handle removing characters one by one in reverse order
        const countDown$ = (0, $afca3285ff834980$export$6788812c4e6611e6)(currentString.split("").reverse()).pipe((0, $cea8e04dbe575457$export$c28c8388be0ab31a)((char, idx)=>(0, $3f0659d06615d3d8$export$ba255e9e49e00608)(char).pipe((0, $4477933faa875af1$export$1391212d75b2ee65)((0, $fdc83e8c8ea069df$export$2e2bcd8739ae039)(10, 40), (0, $9864f9013a045943$export$4dc84b80a0d0c8da)), (0, $992cdff55f780f5c$export$3f23594af5f37336)(()=>removeCharacter(char)) // Remove character
            )));
        // Observable for a long pause after typing the string
        const longPause$ = (0, $3f0659d06615d3d8$export$ba255e9e49e00608)(null).pipe((0, $4477933faa875af1$export$1391212d75b2ee65)(2000));
        // Observable for a short pause before starting to type the next string
        const shortPause$ = (0, $3f0659d06615d3d8$export$ba255e9e49e00608)(null).pipe((0, $4477933faa875af1$export$1391212d75b2ee65)(400));
        if (deleteOnly) // Concatenating the observables to create the full typewriter effect sequence
        return (0, $4195388abc69bf39$export$ee1b3e54f0441b22)(longPause$, countDown$, shortPause$);
        else {
            if (!loop) // This is a hack to allow for 'strings' of one length
            return (0, $4195388abc69bf39$export$ee1b3e54f0441b22)(countUp$);
            else // Concatenating the observables to create the full typewriter effect sequence
            return (0, $4195388abc69bf39$export$ee1b3e54f0441b22)(countUp$, longPause$, countDown$, shortPause$);
        }
    };
    var typewriter$;
    if (loop) typewriter$ = (0, $3f0659d06615d3d8$export$ba255e9e49e00608)(null).pipe((0, $18efc9ac364e445d$export$9f77e0932fb78f72)(()=>{
        const currentString = stringCycler();
        return createTypewriterEffect$(currentString).pipe((0, $cea8e04dbe575457$export$c28c8388be0ab31a)(()=>(0, $3f0659d06615d3d8$export$ba255e9e49e00608)(null)) // Ensures the sequence completes before cycling to the next string
        );
    }, 1) // Controls the concurrency level of the expand operator
    );
    else {
        const currentString = stringCycler();
        typewriter$ = createTypewriterEffect$(currentString).pipe((0, $cea8e04dbe575457$export$c28c8388be0ab31a)(()=>(0, $3f0659d06615d3d8$export$ba255e9e49e00608)(null)) // Ensures the sequence completes before cycling to the next string,
        );
    }
    // If we should startWith a string we need to delete it first
    if (startWith) typewriter$ = (0, $4195388abc69bf39$export$ee1b3e54f0441b22)(createTypewriterEffect$(startWith, true).pipe((0, $cea8e04dbe575457$export$c28c8388be0ab31a)(()=>(0, $3f0659d06615d3d8$export$ba255e9e49e00608)(null)) // Ensures the sequence completes before cycling to the next string
    ), typewriter$);
    // Add the delay
    return typewriter$.pipe((0, $4477933faa875af1$export$1391212d75b2ee65)(delayStart));
}
var $a80cf5dc979e0ed3$export$2e2bcd8739ae039 = $a80cf5dc979e0ed3$var$makeTypewriter;




function $fc357bf89c9e76f7$export$260e5c0943f31606(observableFactory) {
    return new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)(function(subscriber) {
        (0, $73e1b4b68a4d58ca$export$6a9cfa3ebc765910)(observableFactory()).subscribe(subscriber);
    });
}




function $7614a06bb9dad2f3$export$a4fe86229b0e9bdd() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    var scheduler = (0, $ba29b8cd54e70848$export$29534b2f653ae592)(values);
    return (0, $73cdb159b7187545$export$871731df685d7753)(function(source, subscriber) {
        (scheduler ? (0, $4195388abc69bf39$export$ee1b3e54f0441b22)(values, source, scheduler) : (0, $4195388abc69bf39$export$ee1b3e54f0441b22)(values, source)).subscribe(subscriber);
    });
}


function $5b47eca034349f1c$var$getVideoPixelsObservable(videoEl) {
    // Function to create and return the canvas context
    function createCanvasContext(videoEl) {
        const canvas = document.createElement("canvas");
        document.body.appendChild(canvas);
        canvas.style.display = "none"; // Hide the canvas element
        canvas.width = 50;
        canvas.height = 50;
        const ctx = canvas.getContext("2d", {
            willReadFrequently: true
        });
        return {
            canvas: canvas,
            ctx: ctx
        };
    }
    // Function to get the pixel color
    function getPixelColor(ctx) {
        return ()=>{
            // Draw the current video frame to the canvas
            ctx.drawImage(videoEl, 0, 0, ctx.canvas.width, ctx.canvas.height);
            // Calculate the coordinates for the left side of the video, halfway up
            const left = 4;
            const right = ctx.canvas.width - 4;
            const y = Math.floor(ctx.canvas.height / 2);
            // Get the pixel data at the calculated coordinates
            return [
                ctx.getImageData(left, y, 1, 1).data,
                ctx.getImageData(right, y, 1, 1).data
            ];
        };
    }
    // Observable to repeatedly call the function using requestAnimationFrame
    const videoFrame$ = (0, $fc357bf89c9e76f7$export$260e5c0943f31606)(()=>{
        const frame = (timestamp, observer)=>{
            if (!videoEl.paused && !videoEl.ended) {
                observer.next(timestamp);
                requestAnimationFrame((t)=>frame(t, observer));
            }
        };
        return new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)((observer)=>{
            requestAnimationFrame((t)=>frame(t, observer));
        });
    }).pipe((0, $642519524078ad18$export$9007f49c319d1ac7)((0, $9864f9013a045943$export$4dc84b80a0d0c8da)));
    return new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)((subscriber)=>{
        // Create the canvas and get the context
        const { canvas: canvas, ctx: ctx } = createCanvasContext(videoEl);
        // IntersectionObserver to check if the video element is visible
        const intersectionObserver = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    // When the video element is visible, subscribe to the frame observable
                    const subscription = (0, $0f54b2b6fdc78d47$export$a36e16046ae8f1bb)(videoEl, "play").pipe((0, $183291bad0f15980$export$9f6ea8e48bc26eab)(()=>videoFrame$), (0, $a5cbdcd6cbcbc1c4$export$871de8747c9eaa88)(getPixelColor(ctx)), (0, $7614a06bb9dad2f3$export$a4fe86229b0e9bdd)([
                        [
                            0,
                            0,
                            0,
                            0
                        ],
                        [
                            0,
                            0,
                            0,
                            0
                        ]
                    ])).subscribe({
                        next: (pixelData)=>subscriber.next(pixelData),
                        error: (err)=>subscriber.error(err),
                        complete: ()=>{
                            // Cleanup canvas element when the observable completes
                            document.body.removeChild(canvas);
                            subscriber.complete();
                        }
                    });
                    // Return the teardown logic for the observable
                    return ()=>{
                        subscription.unsubscribe();
                        document.body.removeChild(canvas);
                    };
                }
            });
        });
        // Observe the video element
        intersectionObserver.observe(videoEl);
        // Return the teardown logic for the observer
        return ()=>{
            intersectionObserver.disconnect();
            document.body.removeChild(canvas);
        };
    });
}
var $5b47eca034349f1c$export$2e2bcd8739ae039 = $5b47eca034349f1c$var$getVideoPixelsObservable;




var $56daa6a87a4a4216$exports = {};
function $56daa6a87a4a4216$var$extractElementName(src) {
    // Extract the part after the first '/' and before the last two '.'
    const match = src.match(/\/([^/.]+)\.[^/.]+\.[^/.]+$/);
    if (match) return match[1];
    return null;
}
$56daa6a87a4a4216$exports = $56daa6a87a4a4216$var$extractElementName;


function $113e8a60985f919d$var$getIsDebug() {
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.has("debug");
}
var $113e8a60985f919d$export$2e2bcd8739ae039 = $113e8a60985f919d$var$getIsDebug;





function $8b53f2659aa494a0$export$af596f9f0ff848f8(addHandler, removeHandler, resultSelector) {
    if (resultSelector) return $8b53f2659aa494a0$export$af596f9f0ff848f8(addHandler, removeHandler).pipe((0, $785b56a2951e3f7d$export$559affaa48f4288d)(resultSelector));
    return new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)(function(subscriber) {
        var handler = function() {
            var e = [];
            for(var _i = 0; _i < arguments.length; _i++)e[_i] = arguments[_i];
            return subscriber.next(e.length === 1 ? e[0] : e);
        };
        var retValue = addHandler(handler);
        return (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(removeHandler) ? function() {
            return removeHandler(handler, retValue);
        } : undefined;
    });
}


// Helper function to create IntersectionObserver observable
function $968b5da8d9d6563a$var$createInViewObservable(element) {
    return (0, $8b53f2659aa494a0$export$af596f9f0ff848f8)((handler)=>{
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>handler(entry.isIntersecting));
        });
        observer.observe(element);
        return ()=>observer.disconnect();
    }, (handler)=>{});
}
// Create the dwell observable
function $968b5da8d9d6563a$var$createDwellObservable(element, dwellTime = 1000) {
    return $968b5da8d9d6563a$var$createInViewObservable(element).pipe((0, $307eea2e4a0bb811$export$779c5fb865a0172e)(), (0, $183291bad0f15980$export$9f6ea8e48bc26eab)((isInView)=>isInView ? (0, $3f0659d06615d3d8$export$ba255e9e49e00608)(isInView).pipe((0, $a1d5dd94ab71d79a$export$7843a4469d64c07e)(dwellTime)) : (0, $3f0659d06615d3d8$export$ba255e9e49e00608)(false)), (0, $3cf7bf86af55a3de$export$3dea766d36a8935f)((isInView)=>isInView));
}
var $968b5da8d9d6563a$export$2e2bcd8739ae039 = $968b5da8d9d6563a$var$createDwellObservable;


document.addEventListener("DOMContentLoaded", ()=>{
    const isDebug = (0, $113e8a60985f919d$export$2e2bcd8739ae039)();
    if (isDebug) {
        var body = document.querySelector("body");
        body.classList.add("debug");
    }
    var widthBreakpointObservable$ = (0, $c50b073a7df50bca$export$a8d898299aedf3c4)();
    var edits$ = (0, $567bcbf2c48d6a1e$export$2e2bcd8739ae039)();
    if (isDebug) {
        // Breakpoints debug
        var breakpointEl = document.createElement("div");
        // Set the text content of the div
        breakpointEl.textContent = "debug";
        // Apply styles to the div
        Object.assign(breakpointEl.style, {
            position: "fixed",
            bottom: "10px",
            right: "10px",
            backgroundColor: "pink",
            padding: "10px",
            zIndex: "5000" // Ensure it stays on top of other elements
        });
        // Append the div to the body
        document.body.appendChild(breakpointEl);
        widthBreakpointObservable$.subscribe((breakpoint)=>{
            breakpointEl.textContent = breakpoint;
        });
    }
    // Menu links
    const menuLinks = document.querySelectorAll(".menu li a");
    menuLinks.forEach((link)=>{
        if (link.hash && document.querySelector(link.hash)) link.addEventListener("click", function(event) {
            event.preventDefault();
            const targetElement = document.querySelector(link.hash);
            console.log(targetElement);
            const offsetPosition = targetElement.offsetTop - 300;
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        });
    });
    // Cover
    var coverEl = document.querySelector("#cover");
    var coverTextEl = coverEl.querySelector("h1");
    coverEl.remove();
    // var coverSubscription = makeTypewriter({
    //     el: coverTextEl,
    //     strings: [
    //         'Ross Cairns',
    //         'Career Highlights'
    //     ],
    //     onFinishString: (count) => {
    //         if (count === 2) {
    //             coverSubscription.unsubscribe();
    //             setTimeout(() => {
    //                 coverEl.classList.add('removing');
    //                 setTimeout(() => {
    //                     coverEl.remove();
    //                 }, 2000);
    //             }, 333);
    //         }
    //     }
    // }).subscribe();
    // Typewriter
    // var textEl = document.querySelector('#titlewriter');
    // makeTypewriter({
    //     el: textEl,
    //     startWith: textEl.innerText,
    //     strings: [
    //         'Serial Collaborator',
    //         'Dad',
    //         'Nice Guy(?)',
    //         'Coder',
    //         'Design Engineer',
    //         'UX/UI Designer',
    //         'AR Engineer',
    //         'Creative Developer',
    //         'Digital Maker',
    //     ].map(s => s + ',')
    // }).subscribe();
    // Shooglers
    var shooglerHtmlCollection = document.getElementsByTagName("a");
    Array.prototype.forEach.call(shooglerHtmlCollection, (0, $b84c8059b1c60c68$export$2e2bcd8739ae039));
    // Connectors
    var connectorsContainer = document.querySelector("#background");
    var div = document.createElement("div");
    connectorsContainer.prepend(div);
    var connectorsProvider = (0, $526c83f1c3ed1889$export$2e2bcd8739ae039)(div);
    // Solo Boxes
    var soloBoxes = (0, $7551c051cf6c1741$export$2e2bcd8739ae039)(document.getElementsByClassName("solo-box")).forEach((el)=>{
        var mediaEl = el.querySelector("img, video");
        makeMedia(mediaEl, el);
        makeHeightAdjustable(el, el);
        makeDwell(el, el.id);
    });
    // Info Boxes
    var infoBoxes = (0, $7551c051cf6c1741$export$2e2bcd8739ae039)(document.getElementsByClassName("info-box"));
    infoBoxes.forEach(makeInfoBox);
    function makeInfoBox(el) {
        const infoBoxUpdated$ = new (0, $88dc0495baf4925f$export$b6bbab5a9b109038)();
        makeHeightAdjustable(el.parentNode, el);
        const boxEl = el.querySelector(".box");
        const pulloutEl = el.querySelector(".pullout");
        if (pulloutEl) makePullOut(pulloutEl);
        var layout = $fc6757d5075a36d8$var$getLayout(el);
        // Size editing
        var resizable$ = (0, $524b36d8da542765$export$2e2bcd8739ae039)(boxEl, {
            widthOnly: true,
            preserveAspect: false
        });
        resizable$.subscribe(makeEditHandler(el.id, "info"));
        resizable$.subscribe(()=>infoBoxUpdated$.next());
        // Position editing
        var infoDragging$ = (0, $7e1a5774bc26420f$export$2e2bcd8739ae039)(boxEl).pipe((0, $a2772f38b84c6d6a$export$ed80d9de1d9df928)());
        infoDragging$.subscribe(makeEditHandler(el.id, "info"));
        infoDragging$.subscribe(()=>infoBoxUpdated$.next());
        var pictures = (0, $7551c051cf6c1741$export$2e2bcd8739ae039)(el.querySelectorAll(".picture"));
        pictures.forEach((pictureEl)=>{
            var mediaEl = pictureEl.querySelector("img, video");
            var renderConnector = makeConnection(boxEl, mediaEl);
            makeMedia(mediaEl, el).subscribe(()=>{
                renderConnector();
            });
            infoBoxUpdated$.subscribe(()=>{
                renderConnector();
            });
            (0, $987e5ce25fa759ec$export$2e2bcd8739ae039)().subscribe(renderConnector);
        });
        // Size and position applying
        widthBreakpointObservable$.subscribe((_)=>{
            var initialPosition = layout.getElementLayout((0, $c50b073a7df50bca$export$82919ec0c053a4c9)(), "info");
            if (initialPosition.width) {
                boxEl.style.width = initialPosition.width + "px";
                boxEl.style["max-width"] = initialPosition.width + "px";
            } else {
                boxEl.style.removeProperty("width");
                boxEl.style.removeProperty("max-width");
            }
            boxEl.style.transform = `translate(${initialPosition.x}px, ${initialPosition.y}px)`;
            infoBoxUpdated$.next();
        });
        makeDwell(el, el.id);
    }
    function makeDwell(el, id) {
        (0, $968b5da8d9d6563a$export$2e2bcd8739ae039)(el, 2000).pipe((0, $7d538d433736789b$export$b7df5d561049483a)(1)).subscribe(()=>{
            if (!isDebug) {
                if (umami) umami.track(id);
            }
        });
    }
    function makeConnection(boxEl, mediaEl) {
        var elementColorSample = "#0075FF";
        var pixelColorObservable$;
        const strength = 50;
        const offset = 9;
        const zero = new DOMPoint();
        const toOrigin = new DOMPoint();
        const fromOrigin = new DOMPoint();
        const src = mediaEl.getAttribute("src") || mediaEl.querySelector("source").getAttribute("src");
        const isVideo = src.endsWith(".webm");
        const backgroundEl = document.querySelector("#background");
        var connector = connectorsProvider.makeConnector();
        const renderConnector = ()=>{
            const fromTopLeft = (0, $bd77175d445eb58c$export$2e2bcd8739ae039)(boxEl, zero, new DOMPoint(-1, -1));
            const fromCenter = (0, $bd77175d445eb58c$export$2e2bcd8739ae039)(boxEl, zero, zero);
            const fromBottomRight = (0, $bd77175d445eb58c$export$2e2bcd8739ae039)(boxEl, zero, new DOMPoint(1, 1));
            const backgroundOffset = parseInt(window.getComputedStyle(backgroundEl).left);
            const toTopLeft = (0, $bd77175d445eb58c$export$2e2bcd8739ae039)(mediaEl, zero, new DOMPoint(-1, -1));
            const toCenter = (0, $bd77175d445eb58c$export$2e2bcd8739ae039)(mediaEl, zero, zero);
            const toBottomRight = (0, $bd77175d445eb58c$export$2e2bcd8739ae039)(mediaEl, zero, new DOMPoint(1, 1));
            if (fromBottomRight.x < toTopLeft.x) {
                fromOrigin.x = 1;
                fromOrigin.y = 0;
                toOrigin.x = -1;
            } else if (fromTopLeft.x > toBottomRight.x) {
                fromOrigin.x = -1;
                fromOrigin.y = 0;
                toOrigin.x = 1;
            } else {
                fromOrigin.x = 0;
                toOrigin.x = 0;
                if (fromCenter.y < toCenter.y) fromOrigin.y = 1;
                else fromOrigin.y = -1;
                if (toCenter.x > fromCenter.x) toOrigin.x = -1;
                else toOrigin.x = 1;
            }
            const formOffset = (0, $bd77175d445eb58c$export$2e2bcd8739ae039)(boxEl, new DOMPoint(offset * fromOrigin.x - backgroundOffset, offset * fromOrigin.y), fromOrigin);
            const formControl = (0, $bd77175d445eb58c$export$2e2bcd8739ae039)(boxEl, new DOMPoint((offset + strength) * fromOrigin.x - backgroundOffset, (offset + strength) * fromOrigin.y), fromOrigin);
            connector.to(formOffset.x, formOffset.y, formControl.x, formControl.y, "#0075FF");
            const toOffset = (0, $bd77175d445eb58c$export$2e2bcd8739ae039)(mediaEl, new DOMPoint(offset * toOrigin.x - backgroundOffset, offset * toOrigin.y), toOrigin);
            const toControl = (0, $bd77175d445eb58c$export$2e2bcd8739ae039)(mediaEl, new DOMPoint((offset + strength) * toOrigin.x - backgroundOffset, (offset + strength) * toOrigin.y), toOrigin);
            isVideo;
            connector.from(toOffset.x, toOffset.y, toControl.x, toControl.y, elementColorSample);
        };
        // Should be disposable
        setInterval(()=>{
            renderConnector();
        }, 1000);
        renderConnector();
        return renderConnector;
    }
    function makePullOut(pulloutEl) {
        const pulloutContent = pulloutEl.querySelector(".pullout-content");
        const originalText = pulloutContent.innerText;
        var typewriter$;
        (0, $a6dda5b21e9827a9$export$2e2bcd8739ae039)(pulloutEl).subscribe(({ isIntersecting: isIntersecting })=>{
            if (isIntersecting) {
                if (typewriter$) {
                    typewriter$.unsubscribe();
                    typewriter$ = null;
                }
                typewriter$ = (0, $a80cf5dc979e0ed3$export$2e2bcd8739ae039)({
                    delayStart: (0, $fdc83e8c8ea069df$export$2e2bcd8739ae039)(3000, 4000),
                    loop: false,
                    el: pulloutContent,
                    strings: [
                        originalText
                    ]
                }).subscribe(()=>{}, ()=>{}, ()=>{
                    setTimeout(()=>{
                        pulloutContent.innerText = pulloutContent.innerText.slice(0, -1);
                    }, (0, $fdc83e8c8ea069df$export$2e2bcd8739ae039)(300, 777));
                });
            } else {
                if (typewriter$) {
                    typewriter$.unsubscribe();
                    typewriter$ = null;
                }
                pulloutContent.innerText = "";
            }
        });
        pulloutContent.innerText = "";
    }
    // Create an observable that listens to keypress events on the document
    const keypress$ = (0, $0f54b2b6fdc78d47$export$a36e16046ae8f1bb)(document, "keypress").pipe((0, $a2772f38b84c6d6a$export$ed80d9de1d9df928)());
    // Hover over the info box or img/video and press u or j to
    // change the size of the container
    function makeHeightAdjustable(el, scopeEl) {
        var didUpdate$ = new (0, $88dc0495baf4925f$export$b6bbab5a9b109038)();
        var layout = $fc6757d5075a36d8$var$getLayout(scopeEl);
        widthBreakpointObservable$.subscribe((_)=>{
            var elementLayout = layout.getElementLayout((0, $c50b073a7df50bca$export$82919ec0c053a4c9)(), "::parent");
            if (elementLayout && elementLayout.height) el.style.height = elementLayout.height + "px";
        });
        // Create an observable for mouse enter and leave events on the element
        const mouseEnter$ = (0, $0f54b2b6fdc78d47$export$a36e16046ae8f1bb)(el, "mouseenter");
        const mouseLeave$ = (0, $0f54b2b6fdc78d47$export$a36e16046ae8f1bb)(el, "mouseleave");
        // Create an observable that only emits keypress events when the mouse is over the element
        const keypressWhenMouseOver$ = mouseEnter$.pipe((0, $6d95d0a3c23e5dc7$export$6b9f6c0d32c093f9)(()=>keypress$.pipe((0, $4b874ddcbf4a1d4e$export$ac8dfd3a7ad06e80)(mouseLeave$), (0, $a2772f38b84c6d6a$export$ed80d9de1d9df928)())));
        keypressWhenMouseOver$.subscribe(({ key: key })=>{
            var sizeDelta = 0;
            if (key === "u") sizeDelta = 25;
            else if (key === "j") sizeDelta -= 25;
            if (!sizeDelta) return;
            var currentHeight = parseFloat(el.style.height);
            if (!currentHeight) currentHeight = 300;
            var height = currentHeight + sizeDelta;
            el.style.height = height + "px";
            // Make edit packet
            var data = {};
            data[scopeEl.id] = {};
            data[scopeEl.id][(0, $c50b073a7df50bca$export$82919ec0c053a4c9)()] = {};
            data[scopeEl.id][(0, $c50b073a7df50bca$export$82919ec0c053a4c9)()]["::parent"] = {
                height: height
            };
            // Send the edits
            edits$.next(data);
            didUpdate$.next();
        });
        return didUpdate$;
    }
    function makeMedia(mediaEl, scopeEl) {
        var didUpdate$ = new (0, $88dc0495baf4925f$export$b6bbab5a9b109038)();
        const src = mediaEl.getAttribute("src") || mediaEl.querySelector("source").getAttribute("src");
        var elementName = (0, (/*@__PURE__*/$parcel$interopDefault($56daa6a87a4a4216$exports)))(src);
        var layout = $fc6757d5075a36d8$var$getLayout(scopeEl);
        // Size and position applying
        const originalWidth = mediaEl.style.width;
        const originalHeight = mediaEl.style.height;
        widthBreakpointObservable$.subscribe((_)=>{
            var initialPosition = layout.getElementLayout((0, $c50b073a7df50bca$export$82919ec0c053a4c9)(), elementName);
            mediaEl.style.transform = `translate(${initialPosition.x}px, ${initialPosition.y}px)`;
            if (initialPosition.width) mediaEl.style.width = initialPosition.width + "px";
            else mediaEl.style.width = originalWidth;
            if (initialPosition.height) mediaEl.style.height = initialPosition.height + "px";
            else mediaEl.style.height = originalHeight;
        });
        (0, $7e1a5774bc26420f$export$2e2bcd8739ae039)(mediaEl).subscribe((v)=>{
            // Make edit packet
            var data = {};
            data[scopeEl.id] = {};
            data[scopeEl.id][(0, $c50b073a7df50bca$export$82919ec0c053a4c9)()] = {};
            data[scopeEl.id][(0, $c50b073a7df50bca$export$82919ec0c053a4c9)()][elementName] = v;
            // Send the edits
            edits$.next(data);
            didUpdate$.next();
        });
        // Resizing
        (0, $524b36d8da542765$export$2e2bcd8739ae039)(mediaEl).subscribe((v)=>{
            // Make edit packet
            var data = {};
            data[scopeEl.id] = {};
            data[scopeEl.id][(0, $c50b073a7df50bca$export$82919ec0c053a4c9)()] = {};
            data[scopeEl.id][(0, $c50b073a7df50bca$export$82919ec0c053a4c9)()][elementName] = v;
            // Send the edits
            edits$.next(data);
            didUpdate$.next();
        });
        return didUpdate$;
    }
    function makeEditHandler(id, elementName) {
        return (v)=>{
            // Make edit packet
            var data = {};
            data[id] = {};
            data[id][(0, $c50b073a7df50bca$export$82919ec0c053a4c9)()] = {};
            data[id][(0, $c50b073a7df50bca$export$82919ec0c053a4c9)()][elementName] = v;
            // Send the edits
            edits$.next(data);
        };
    }
});
// Utils
function $fc6757d5075a36d8$var$getLayout(el) {
    var layout = el.getAttribute("data-layout");
    try {
        layout = JSON.parse(layout);
    } catch (err) {
        layout = {};
    }
    if (layout === null) layout = {};
    var breakpoints = Array.from((0, $c50b073a7df50bca$export$b74b67df3223ddfa)().keys());
    function getPreviousBreakpoint(currentKey) {
        const currentIndex = breakpoints.indexOf(currentKey);
        if (currentIndex > 0) return breakpoints[currentIndex - 1];
        else return null; // or handle the case where there is no previous element
    }
    function getElementLayout(breakpointName, elementName) {
        if (layout[breakpointName] && layout[breakpointName][elementName]) return layout[breakpointName][elementName];
        const previousBreakpoint = getPreviousBreakpoint(breakpointName);
        if (!previousBreakpoint) return {
            x: 0,
            y: 0,
            width: null,
            height: null
        };
        else return getElementLayout(previousBreakpoint, elementName);
    }
    return {
        getElementLayout: getElementLayout
    };
}
function $fc6757d5075a36d8$var$getTranslateValues(element) {
    const style = window.getComputedStyle(element);
    const transform = style.transform;
    // Check if the transform is none or not specified
    if (!transform || transform === "none") return {
        x: 0,
        y: 0
    };
    // Use a regular expression to extract the translate values
    const match = transform.match(/translate\(\s*([^\s,)]+)[ ,]([^\s,)]+)/);
    if (match) return {
        x: parseFloat(match[1]),
        y: parseFloat(match[2])
    };
    else return {
        x: 0,
        y: 0
    };
}
// function measureRepaints() {
//     let previousTimestamp = performance.now();
//     function animate(timestamp) {
//         const timeSinceLastPaint = timestamp - previousTimestamp;
//         previousTimestamp = timestamp;
//         // Log the time between repaints
//         console.log(`Time since last paint: ${timeSinceLastPaint.toFixed(2)} ms`);
//         // Your animation code here...
//         // Request the next frame
//         requestAnimationFrame(animate);
//     }
//     // Start the animation loop
//     requestAnimationFrame(animate);
// }
// measureRepaints();
// animationFrameObservable().subscribe(v => {
//     console.log("Update");
// })
console.log("\uD83D\uDC4B");


//# sourceMappingURL=index.e5d043db.js.map
